import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prompts');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";


@Component({
    selector: 'wiz-page-prompts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prompts/view.scss */
:host {
  min-width: 0;
  container: page-prompts/inline-size;
  display: block;
  min-height: 100%;
  background: var(--wb-page-canvas, #f5f9fd);
}

.prompt-criteria-shell {
  min-width: 0;
}

.prompt-criteria-category-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 18px;
}

.prompt-criteria-category-tabs .prompt-criteria-tab {
  justify-content: center;
  min-height: 48px;
  border-radius: 7px;
  background: #fff;
  color: #31476c;
  font-size: 13px;
}

.prompt-criteria-category-tabs .prompt-criteria-tab.is-selected {
  border-color: #1465ed;
  background: #eef5ff;
  color: #0958d9;
}

.prompt-criteria-loading, .prompt-criteria-error {
  padding: 28px;
  border: 1px solid #dce7f7;
  border-radius: 8px;
  background: #fff;
  color: #5b7190;
}

.prompt-criteria-error {
  border-color: #f3bbb6;
  color: #ac4137;
}

.prompt-criteria-workspace {
  display: grid;
  grid-template-columns: minmax(300px, 36%) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.prompt-criteria-list, .prompt-criteria-detail {
  min-width: 0;
  border: 1px solid #dbe6f4;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 3px 14px rgba(37, 72, 123, 0.035);
}

.prompt-criteria-list {
  overflow: hidden;
}

.prompt-criteria-rows {
  max-height: 520px;
  overflow-y: auto;
}

.prompt-criteria-cut-browser {
  padding: 18px 24px 24px;
}

.prompt-criteria-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
  margin: 0 0 18px;
  color: #6b82a2;
  font-size: 12px;
}

.prompt-criteria-breadcrumb.is-padded {
  padding: 16px 24px 0;
}

.prompt-criteria-breadcrumb button {
  border: 0;
  padding: 2px 0;
  background: transparent;
  color: #2465c9;
  cursor: pointer;
  font: inherit;
}

.prompt-criteria-breadcrumb i {
  font-size: 8px;
}

.prompt-criteria-breadcrumb strong {
  color: #23436d;
}

.prompt-criteria-cut-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
}

.prompt-criteria-cut-card {
  position: relative;
  display: grid;
  gap: 8px;
  min-width: 0;
  padding: 18px;
  border: 1px solid #dbe6f4;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.prompt-criteria-cut-card:hover, .prompt-criteria-cut-card:focus-visible {
  outline: 2px solid #5f95f4;
  outline-offset: 1px;
  background: #f8fbff;
}

.prompt-criteria-cut-card > strong {
  color: #173760;
  font-size: 16px;
}

.prompt-criteria-cut-card > span:not(.prompt-criteria-memory-kind), .prompt-criteria-cut-card small {
  color: #7185a2;
  font-size: 11px;
}

.prompt-criteria-cut-card small {
  padding-right: 18px;
}

.prompt-criteria-cut-card > i {
  position: absolute;
  right: 18px;
  bottom: 18px;
  color: #6590cd;
  font-size: 12px;
}

.prompt-criteria-memory-kind {
  justify-self: start;
  padding: 3px 7px;
  border-radius: 4px;
  background: #edf4ff;
  color: #3770c0;
  font-size: 11px;
  font-weight: 700;
}

.prompt-criteria-memory-kind.is-positive {
  color: #277865;
  background: #edf8f3;
}

.prompt-criteria-versions {
  padding: 0 24px 16px;
  border-bottom: 1px solid #e5edf7;
}

.prompt-criteria-versions-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.prompt-criteria-versions-heading h3 {
  margin: 0;
  color: #25446f;
  font-size: 13px;
  font-weight: 700;
}

.prompt-criteria-versions-heading > span {
  color: #7890ae;
  font-size: 11px;
}

.prompt-criteria-version-list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 2px 2px 7px;
}

.prompt-criteria-version-list button {
  flex: 0 0 160px;
  display: grid;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid #dbe6f4;
  border-radius: 6px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.prompt-criteria-version-list button.is-selected {
  border-color: #1766e9;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px #1766e9;
}

.prompt-criteria-version-list strong {
  color: #2258a0;
  font-size: 13px;
}

.prompt-criteria-version-list span, .prompt-criteria-version-list small {
  color: #6c84a7;
  font-size: 11px;
}

.prompt-criteria-versions .prompt-criteria-version-note {
  margin: 6px 0 0;
}

.prompt-criteria-list-title {
  padding: 21px 22px 15px;
}

.prompt-criteria-list-title h2, .prompt-criteria-detail-header h2 {
  margin: 0;
  color: #13284d;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.35;
}

.prompt-criteria-list-title p, .prompt-criteria-detail-header p {
  margin: 5px 0 0;
  color: #7186a4;
  font-size: 12px;
  line-height: 1.5;
}

.prompt-criteria-base-row {
  margin: 0;
  padding: 0 17px 13px;
  border-bottom: 1px solid #e5edf7;
}

.prompt-criteria-base-row.is-selected {
  background: linear-gradient(90deg, #f0f6ff, #fff 82%);
}

.prompt-criteria-list-select {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  min-height: 60px;
  padding: 8px 5px;
  border: 0;
  background: transparent;
  color: #15305b;
  text-align: left;
}

.prompt-criteria-list-select:disabled {
  cursor: not-allowed;
}

.prompt-criteria-pin {
  display: grid;
  place-items: center;
  flex: 0 0 31px;
  width: 31px;
  height: 31px;
  border-radius: 7px;
  background: #e6f0ff;
  color: #1263e8;
}

.prompt-criteria-list-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
  flex: 1;
}

.prompt-criteria-list-copy strong {
  font-size: 13px;
}

.prompt-criteria-list-copy small {
  overflow: hidden;
  color: #7690b2;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-criteria-fixed {
  padding: 4px 8px;
  border-radius: 99px;
  background: #eaf1ff;
  color: #1261e7;
  font-size: 10px;
  font-weight: 800;
}

.prompt-criteria-base-actions {
  display: flex;
  gap: 7px;
  padding-left: 42px;
}

.prompt-criteria-subaction {
  padding: 5px 9px;
  border: 1px solid #cdddf3;
  border-radius: 6px;
  background: #fff;
  color: #1d5bbf;
  font-size: 11px;
  font-weight: 700;
}

.prompt-criteria-subaction:hover {
  border-color: #4388ed;
  background: #f4f8ff;
}

.prompt-criteria-list-divider {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px 9px;
  color: #17335a;
  font-size: 12px;
}

.prompt-criteria-list-divider small {
  color: #8295af;
  font-size: 11px;
}

.prompt-criteria-search {
  display: flex;
  margin: 0 21px 10px;
  border: 1px solid #d5e1f1;
  border-radius: 6px;
  background: #fff;
}

.prompt-criteria-search:focus-within {
  border-color: #2474ed;
  box-shadow: 0 0 0 2px #e0edff;
}

.prompt-criteria-search input {
  min-width: 0;
  flex: 1;
  padding: 10px 11px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #17335a;
  font-size: 12px;
}

.prompt-criteria-search button {
  width: 42px;
  border: 0;
  background: transparent;
  color: #57749d;
}

.prompt-criteria-scope {
  display: flex;
  gap: 6px;
  padding: 0 21px 13px;
}

.prompt-criteria-scope button {
  padding: 6px 12px;
  border: 1px solid #d6e3f5;
  border-radius: 5px;
  background: #fff;
  color: #547092;
  font-size: 11px;
  font-weight: 700;
}

.prompt-criteria-scope button.is-selected {
  border-color: #1263e8;
  background: #1263e8;
  color: #fff;
}

.prompt-criteria-list-message {
  margin: 0;
  padding: 20px 22px;
  color: #7488a4;
  font-size: 12px;
  line-height: 1.6;
}

.prompt-criteria-list-message.is-error {
  color: #b44640;
}

.prompt-criteria-rows {
  border-top: 1px solid #e8eef7;
}

.prompt-criteria-draft-row {
  position: relative;
  display: grid;
  gap: 4px;
  width: 100%;
  min-height: 92px;
  padding: 16px 37px 14px 22px;
  border: 0;
  border-bottom: 1px solid #e8eef7;
  background: #fff;
  text-align: left;
}

.prompt-criteria-draft-row:hover, .prompt-criteria-draft-row.is-selected {
  background: #edf5ff;
}

.prompt-criteria-draft-row.is-selected {
  box-shadow: inset 3px 0 #1465ed;
}

.prompt-criteria-draft-row:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.prompt-criteria-draft-row strong {
  overflow: hidden;
  color: #18325b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-criteria-draft-row span {
  color: #486992;
  font-size: 11px;
}

.prompt-criteria-draft-row small {
  color: #8499b4;
  font-size: 10px;
}

.prompt-criteria-draft-row i {
  position: absolute;
  top: 42px;
  right: 17px;
  color: #6f91bd;
  font-size: 11px;
}

.prompt-criteria-pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  color: #6982a3;
  font-size: 11px;
}

.prompt-criteria-pager button {
  border: 0;
  background: transparent;
  color: #1764d9;
  font-weight: 700;
}

.prompt-criteria-pager button:disabled {
  opacity: 0.35;
}

.prompt-criteria-detail {
  overflow: hidden;
}

.prompt-criteria-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e6edf7;
}

.prompt-criteria-eyebrow {
  display: block;
  margin-bottom: 7px;
  color: #1c68d8;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.03em;
}

.prompt-criteria-edit-note {
  margin: 0;
  padding: 10px 24px;
  background: #eef5ff;
  color: #1c5db8;
  font-size: 12px;
}

.prompt-criteria-edit-actions {
  display: flex;
  gap: 8px;
  padding: 12px 24px 0;
}

.prompt-criteria-save-footer {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 18px;
  padding: 17px 24px;
  border-top: 1px solid #e6edf7;
}

.prompt-criteria-save-footer label {
  min-width: 0;
  flex: 1;
}

.prompt-criteria-readonly {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border-radius: 6px;
  background: #f0f4f8;
  color: #6b7f9b;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.prompt-criteria-lineage {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  align-items: center;
  margin: 18px 24px 0;
  padding: 12px 14px;
  border-radius: 7px;
  background: #f3f7fc;
  color: #637d9f;
  font-size: 11px;
}

.prompt-criteria-lineage strong {
  color: #1d62d3;
}

.prompt-criteria-lineage i {
  font-size: 8px;
}

.prompt-criteria-version-note {
  margin: 12px 24px;
  color: #8395ad;
  font-size: 11px;
  line-height: 1.6;
}

.prompt-criteria-draft-detail {
  display: grid;
  gap: 13px;
  padding: 14px 24px 20px;
}

.prompt-criteria-levels {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
}

.prompt-criteria-levels button {
  min-height: 43px;
  padding: 7px 4px;
  border: 1px solid #d7e3f3;
  border-radius: 6px;
  background: #fff;
  color: #516e97;
  font-size: 11px;
  font-weight: 700;
}

.prompt-criteria-levels button.is-selected {
  border-color: #1766e9;
  background: #edf5ff;
  color: #0e58d4;
}

.prompt-criteria-inherited, .prompt-criteria-local {
  padding: 17px;
  border: 1px solid #dce6f3;
  border-radius: 7px;
  background: #f8fbff;
}

.prompt-criteria-local {
  border-color: #cbddfb;
  background: #edf5ff;
}

.prompt-criteria-inherited h3, .prompt-criteria-local h3 {
  margin: 0 0 9px;
  color: #183359;
  font-size: 12px;
  font-weight: 800;
}

.prompt-criteria-inherited p, .prompt-criteria-local p, .prompt-criteria-local li {
  margin: 0;
  color: #425d81;
  font-size: 12px;
  line-height: 1.7;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.prompt-criteria-local ul {
  margin: 0;
  padding-left: 18px;
}

.prompt-criteria-inherited .prompt-criteria-negative {
  margin-top: 11px;
  color: #6a7e98;
}

.prompt-criteria-empty {
  color: #8194af !important;
  font-size: 12px;
}

.prompt-model-picker {
  display: block;
  max-width: 640px;
}

.prompt-model-picker-control {
  position: relative;
  display: block;
}

.prompt-model-picker-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-height: 52px;
  padding: 8px 9px 8px 16px;
  border: 1px solid #bdd2f0;
  border-radius: 10px;
  background: #f8fbff;
  color: #17345f;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.prompt-model-picker-trigger > span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-model-picker-trigger:hover {
  border-color: #2474ed;
  background: #f3f8ff;
}

.prompt-model-picker-trigger:focus-visible {
  outline: 3px solid rgba(20, 101, 237, 0.18);
  outline-offset: 1px;
  border-color: #1465ed;
}

.prompt-model-picker-control.is-open .prompt-model-picker-trigger {
  border-color: #1465ed;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(20, 101, 237, 0.12);
}

.prompt-model-picker-affordance {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  border-radius: 7px;
  background: #e6f0ff;
  color: #155dcb;
  font-size: 12px;
  font-weight: 800;
  pointer-events: none;
}

.prompt-model-picker-affordance i {
  font-size: 10px;
}

.prompt-model-picker-control.is-open .prompt-model-picker-affordance i {
  transform: rotate(180deg);
}

.prompt-model-picker-menu {
  position: absolute;
  z-index: 45;
  top: calc(100% + 7px);
  left: 0;
  display: grid;
  width: 100%;
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #c8d9ef;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 38px rgba(24, 61, 112, 0.18);
}

.prompt-model-picker-menu button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 42px;
  padding: 9px 11px;
  border: 0;
  border-radius: 7px;
  background: #fff;
  color: #29466f;
  font-size: 13px;
  font-weight: 650;
  text-align: left;
  cursor: pointer;
}

.prompt-model-picker-menu button:hover, .prompt-model-picker-menu button:focus-visible {
  outline: 0;
  background: #f1f6ff;
  color: #0958d9;
}

.prompt-model-picker-menu button.is-selected {
  background: #e8f1ff;
  color: #0958d9;
  font-weight: 800;
}

.prompt-model-picker-menu button i {
  flex: 0 0 auto;
  color: #1465ed;
  font-size: 11px;
}

.prompt-model-picker-help {
  display: block;
  margin-top: 7px;
  color: #7186a4;
  font-size: 12px;
  line-height: 1.5;
}

.prompt-criteria-draft-footer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 17px 24px 0;
  border-top: 1px solid #e6edf7;
}

.prompt-criteria-draft-footer .prompt-primary-button {
  text-decoration: none;
}

.prompt-criteria-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: safe center;
  justify-content: center;
  overflow-y: auto;
  padding: 18px;
  background: rgba(9, 25, 53, 0.56);
}

.prompt-criteria-modal {
  display: flex;
  flex-direction: column;
  width: min(960px, 100%);
  max-height: min(760px, 100%);
  overflow-y: auto;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(0, 25, 61, 0.25);
}

.prompt-criteria-modal-header {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 23px;
  border-bottom: 1px solid #e3ebf6;
}

.prompt-criteria-modal-header h2 {
  margin: 0;
  color: #142d52;
  font-size: 18px;
  font-weight: 800;
}

.prompt-criteria-modal-header p {
  margin: 5px 0 0;
  color: #7086a4;
  font-size: 12px;
}

.prompt-criteria-modal-header button {
  align-self: start;
  width: 34px;
  height: 34px;
  border: 1px solid #d6e3f3;
  border-radius: 6px;
  background: #fff;
  color: #516c91;
}

.prompt-criteria-modal-grid {
  display: grid;
  grid-template-columns: minmax(220px, 34%) minmax(0, 1fr);
  min-height: 0;
  overflow: auto;
}

.prompt-criteria-modal-list {
  overflow: auto;
  border-right: 1px solid #e3ebf6;
}

.prompt-criteria-modal-list button {
  display: grid;
  gap: 5px;
  width: 100%;
  padding: 14px 17px;
  border: 0;
  border-bottom: 1px solid #e8eef6;
  background: #fff;
  text-align: left;
}

.prompt-criteria-modal-list button.is-selected {
  background: #eef5ff;
  box-shadow: inset 3px 0 #1465ed;
}

.prompt-criteria-modal-list .prompt-criteria-pager button {
  display: inline;
  width: auto;
  padding: 3px 5px;
  border: 0;
  background: transparent;
  text-align: center;
}

.prompt-criteria-modal-list strong {
  color: #1b375f;
  font-size: 12px;
}

.prompt-criteria-modal-list span, .prompt-criteria-modal-list small {
  color: #7890ae;
  font-size: 11px;
}

.prompt-criteria-modal-content {
  overflow: auto;
  max-height: 650px;
  padding: 22px;
}

.prompt-criteria-modal-content h3 {
  margin: 17px 0 6px;
  color: #1a365d;
  font-size: 13px;
  font-weight: 800;
}

.prompt-criteria-modal-content p {
  margin: 0 0 12px;
  color: #425b7c;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.prompt-criteria-modal-meta {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5edf7;
  color: #17345b;
  font-size: 12px;
}

.prompt-criteria-history-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 14px 0;
}

.prompt-criteria-history-tabs button {
  padding: 7px 10px;
  border: 1px solid #d7e3f3;
  border-radius: 6px;
  background: #fff;
  color: #58708f;
  font-size: 11px;
  font-weight: 700;
}

.prompt-criteria-history-tabs button.is-selected {
  border-color: #1766e9;
  background: #edf5ff;
  color: #0e58d4;
}

.prompt-criteria-modal-content .prompt-primary-button {
  margin-top: 13px;
}

.prompt-criteria-modal-message {
  padding: 26px;
  color: #7489a6;
  font-size: 12px;
}

.prompt-criteria-modal-message.is-error {
  color: #b54640;
}

@container page-prompts (max-width: 1000px) {
  .prompt-criteria-workspace {
    grid-template-columns: 1fr;
  }
  .prompt-criteria-category-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@container page-prompts (max-width: 640px) {
  .prompt-criteria-category-tabs {
    grid-template-columns: 1fr 1fr;
  }
  .prompt-criteria-category-tabs .prompt-criteria-tab {
    font-size: 11px;
    padding: 7px;
  }
  .prompt-criteria-levels {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .prompt-criteria-levels button {
    font-size: 10px;
  }
  .prompt-criteria-detail-header, .prompt-criteria-save-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .prompt-criteria-modal-grid {
    grid-template-columns: 1fr;
  }
  .prompt-criteria-modal-list {
    max-height: 180px;
    border-right: 0;
    border-bottom: 1px solid #e3ebf6;
  }
}
.prompt-criteria-mode-active {
  border-color: #2563eb !important;
  background: #eff6ff !important;
  color: #1d4ed8 !important;
}

.prompt-criteria-tab {
  display: inline-flex;
  cursor: pointer;
  min-height: 2.5rem;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0.5rem 0.875rem;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
}

.prompt-criteria-tab:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.prompt-criteria-tab.is-selected {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.prompt-criteria-tab:focus-visible,
.prompt-criteria-mode-active:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: 2px;
}

.prompt-expression-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  max-width: 42rem;
}

.prompt-expression-tab {
  display: inline-flex;
  min-height: 2.75rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.6rem 0.9rem;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
.prompt-expression-tab:hover, .prompt-expression-tab:focus-visible {
  border-color: #93c5fd;
  color: #1d4ed8;
  outline: none;
}
.prompt-expression-tab.is-selected {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  box-shadow: 0 0 0 1px #2563eb;
}

.prompt-expression-panel {
  border: 1px solid #dbe3ee;
  border-radius: 1rem;
  background: #f8fafc;
  padding: 1.25rem;
}

.prompt-readonly-card {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 0.875rem;
  background: #fff;
  padding: 1rem;
}
.prompt-readonly-card.is-negative {
  border-color: #fed7aa;
  background: #fffaf5;
}

.prompt-readonly-text {
  color: #334155;
  font-size: 0.8125rem;
  line-height: 1.55rem;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.prompt-readonly-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #e0e7ff;
  padding: 0.3rem 0.65rem;
  color: #4338ca;
  font-size: 0.6875rem;
  font-weight: 700;
}

@container page-prompts (max-width: 640px) {
  .prompt-expression-tabs {
    grid-template-columns: 1fr;
  }
}
.prompt-toolbar-refresh {
  display: inline-flex;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #475569;
  font-size: 14px;
}

.prompt-toolbar-refresh:hover:not(:disabled) {
  border-color: #93b8e8;
  background: #eff6ff;
  color: #0967c2;
}

.prompt-toolbar-refresh:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.prompt-primary-button,
.prompt-secondary-button,
.prompt-save-button,
.prompt-publish-button,
.prompt-delete-button {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 0.625rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}

.prompt-primary-button,
.prompt-save-button {
  border: 1px solid #4f46e5;
  background: #4f46e5;
  color: #fff;
}
.prompt-primary-button:hover:not(:disabled),
.prompt-save-button:hover:not(:disabled) {
  background: #4338ca;
}

.prompt-secondary-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}
.prompt-secondary-button:hover:not(:disabled) {
  background: #f8fafc;
}

.prompt-publish-button {
  border: 1px solid #059669;
  background: #ecfdf5;
  color: #047857;
}
.prompt-publish-button:hover:not(:disabled) {
  background: #d1fae5;
}

.prompt-delete-button {
  border: 1px solid #fecaca;
  background: #fff;
  color: #dc2626;
}
.prompt-delete-button:hover:not(:disabled) {
  border-color: #fca5a5;
  background: #fef2f2;
  color: #b91c1c;
}

.prompt-primary-button:disabled,
.prompt-secondary-button:disabled,
.prompt-save-button:disabled,
.prompt-publish-button:disabled,
.prompt-delete-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.prompt-catalog-layout {
  display: grid;
  align-items: start;
  gap: 1.25rem;
}

.prompt-area-item {
  display: flex;
  width: 100%;
  min-height: 3.75rem;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.75rem;
  padding: 0.7rem;
  color: #475569;
  text-align: left;
}

.prompt-area-item:hover,
.prompt-area-item:focus-visible {
  background: #f8fafc;
  outline: none;
}

.prompt-area-item.is-selected {
  border-color: #c7d2fe;
  background: #eef2ff;
  color: #312e81;
}

.prompt-area-item small {
  color: #64748b;
}

.prompt-area-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #f1f5f9;
}

.prompt-area-item.is-selected .prompt-area-icon {
  background: #fff;
  color: #4f46e5;
}

.prompt-context-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 1rem 1.25rem;
}

.prompt-context-bar .prompt-select {
  max-width: 30rem;
}

.prompt-theme-panel {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.prompt-search-input {
  width: 100%;
  min-height: 2.625rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.625rem 0.75rem 0.625rem 2.25rem;
  font-size: 0.75rem;
  color: #0f172a;
  outline: none;
}
.prompt-search-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.prompt-search-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.prompt-search-select {
  min-width: 0;
  min-height: 2.375rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0.5rem 0.625rem;
  font-size: 0.6875rem;
  color: #475569;
  outline: none;
}
.prompt-search-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.prompt-search-select-wide {
  grid-column: 1/-1;
}

.prompt-theme-list {
  max-height: 38rem;
  overflow-y: auto;
  padding: 0.5rem;
}

.prompt-draft-item {
  display: flex;
  width: 100%;
  align-items: stretch;
  margin-bottom: 0.375rem;
  overflow: hidden;
  border: 1px dashed #a78bfa;
  border-radius: 0.75rem;
  background: #faf5ff;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}
.prompt-draft-item:hover {
  border-color: #8b5cf6;
  background: #f5f3ff;
}
.prompt-draft-item.is-selected {
  border-style: solid;
  border-color: #8b5cf6;
  background: #f5f3ff;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
}

.prompt-draft-open {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
}

.prompt-draft-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #fff;
  color: #7c3aed;
  box-shadow: 0 1px 2px rgba(76, 29, 149, 0.1);
}

.prompt-draft-copy {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-align: left;
}

.prompt-draft-title,
.prompt-draft-meta {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-draft-title {
  color: #2e1065;
  font-size: 0.8125rem;
  font-weight: 800;
  line-height: 1.25rem;
}

.prompt-draft-meta {
  margin-top: 0.25rem;
  color: #7c3aed;
  font-size: 0.6875rem;
  line-height: 1rem;
}

.prompt-draft-discard {
  width: 2.5rem;
  flex: 0 0 auto;
  border-left: 1px solid rgba(167, 139, 250, 0.35);
  color: #8b5cf6;
}
.prompt-draft-discard:hover, .prompt-draft-discard:focus-visible {
  background: #ede9fe;
  color: #6d28d9;
  outline: none;
}

.prompt-theme-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.75rem;
  padding: 0.75rem;
  color: #475569;
  transition: background-color 140ms ease, border-color 140ms ease;
}
.prompt-theme-item:hover {
  background: #f8fafc;
}
.prompt-theme-item.is-selected {
  border-color: #c7d2fe;
  background: #eef2ff;
}

.prompt-theme-item-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #f1f5f9;
  color: #64748b;
}
.is-selected .prompt-theme-item-icon {
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.prompt-status-badge {
  display: inline-flex;
  min-height: 1.625rem;
  align-items: center;
  gap: 0.375rem;
  border-radius: 9999px;
  padding: 0.25rem 0.625rem;
  font-size: 0.625rem;
  font-weight: 800;
}

.prompt-version-chip {
  display: inline-flex;
  min-height: 2rem;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #fff;
  padding: 0.35rem 0.7rem;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
}
.prompt-version-chip:hover, .prompt-version-chip.is-selected {
  border-color: #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
}

.prompt-expand-button {
  display: inline-flex;
  min-height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0.45rem 0.75rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 800;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
.prompt-expand-button:hover, .prompt-expand-button:focus-visible {
  border-color: #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
  outline: none;
}

.prompt-expanded-backdrop {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: safe center;
  justify-content: center;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.72);
  padding: 1rem;
}

.prompt-expanded-dialog {
  display: flex;
  width: min(100%, 90rem);
  height: min(100%, 58rem);
  max-height: 100%;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.32);
  outline: none;
}

.prompt-expanded-header,
.prompt-expanded-footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
}

.prompt-expanded-header {
  border-bottom: 1px solid #e2e8f0;
}

.prompt-expanded-footer {
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.prompt-expanded-close {
  display: inline-flex;
  min-height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border-radius: 0.625rem;
  padding: 0.5rem 0.75rem;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
}
.prompt-expanded-close:hover, .prompt-expanded-close:focus-visible {
  background: #f1f5f9;
  color: #0f172a;
  outline: none;
}

.prompt-expanded-body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  padding: 1.25rem;
}

.prompt-expanded-body > * {
  flex-shrink: 0;
}

.prompt-expanded-fields {
  display: grid;
  min-height: 36rem;
  flex: 1 1 auto;
  grid-template-rows: minmax(20rem, 3fr) minmax(12rem, 2fr);
  gap: 1rem;
}
.prompt-expanded-fields.is-single {
  grid-template-rows: minmax(34rem, 1fr);
}

.prompt-expanded-field {
  display: flex;
  min-height: 0;
  flex-direction: column;
  gap: 0.5rem;
}

.prompt-expanded-textarea {
  min-height: 0;
  flex: 1 1 auto;
  resize: none;
}

.prompt-editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.prompt-area-heading {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.9rem 1.5rem;
  color: #0f172a;
  font-size: 0.875rem;
  font-weight: 800;
}

.prompt-set-details {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.8rem 1rem;
}

.prompt-set-details > summary {
  cursor: pointer;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
}

.prompt-set-details > summary:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 3px;
}

.prompt-rule-panel {
  max-width: 60rem;
  padding: 0 1.5rem 1.5rem;
}

.prompt-field-label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
}

.prompt-field-help {
  display: block;
  margin-top: 0.4rem;
  font-size: 0.6875rem;
  line-height: 1.25rem;
  color: #94a3b8;
}

.prompt-model-format {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  border: 1px solid #dbeafe;
  border-radius: 0.75rem;
  background: #eff6ff;
  padding: 0.7rem 0.8rem;
  color: #1d4ed8;
}
.prompt-model-format > i {
  margin-top: 0.15rem;
  font-size: 0.75rem;
}
.prompt-model-format strong {
  display: block;
  font-size: 0.6875rem;
}
.prompt-model-format p {
  margin-top: 0.15rem;
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.05rem;
}
.prompt-model-format.is-split {
  border-color: #ddd6fe;
  background: #f5f3ff;
  color: #6d28d9;
}

.prompt-model-recipe {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.875rem;
  background: #fff;
}
.prompt-model-recipe > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 0.9rem 0.65rem;
}
.prompt-model-recipe > header strong {
  color: #0f172a;
  font-size: 0.75rem;
}
.prompt-model-recipe > header p {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.1rem;
}
.prompt-model-recipe > header button {
  display: inline-flex;
  min-height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border-radius: 0.55rem;
  background: #4f46e5;
  padding: 0.4rem 0.65rem;
  color: #fff;
  font-size: 0.625rem;
  font-weight: 700;
}
.prompt-model-recipe > header button:hover:not(:disabled), .prompt-model-recipe > header button:focus-visible:not(:disabled) {
  background: #4338ca;
  outline: none;
}
.prompt-model-recipe > header button:disabled {
  background: #e2e8f0;
  color: #64748b;
}
.prompt-model-recipe > details {
  border-top: 1px solid #f1f5f9;
}
.prompt-model-recipe > details summary {
  display: flex;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0.9rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
}
.prompt-model-recipe > details summary::-webkit-details-marker {
  display: none;
}
.prompt-model-recipe > details[open] summary > i {
  transform: rotate(180deg);
}
.prompt-model-recipe > details summary > i {
  font-size: 0.625rem;
  transition: transform 160ms ease;
}
.prompt-model-recipe > details p {
  border-top: 1px solid #f1f5f9;
  background: #f8fafc;
  padding: 0.75rem 0.9rem;
  color: #475569;
  font-size: 0.6875rem;
  line-height: 1.2rem;
  white-space: pre-wrap;
}

.prompt-model-structure {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0 0.9rem 0.8rem;
}
.prompt-model-structure span {
  border-radius: 999px;
  background: #eef2ff;
  padding: 0.25rem 0.5rem;
  color: #4338ca;
  font-size: 0.625rem;
  font-weight: 700;
}

.prompt-input,
.prompt-select,
.prompt-textarea,
.prompt-code-textarea,
.prompt-rule-textarea {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  color: #0f172a;
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.prompt-input:focus,
.prompt-select:focus,
.prompt-textarea:focus,
.prompt-code-textarea:focus,
.prompt-rule-textarea:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.prompt-input:disabled,
.prompt-select:disabled,
.prompt-textarea:disabled,
.prompt-code-textarea:disabled,
.prompt-rule-textarea:disabled {
  cursor: default;
  background: #f8fafc;
  color: #64748b;
}

.prompt-input,
.prompt-select {
  min-height: 2.75rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.8125rem;
}

.prompt-textarea,
.prompt-rule-textarea {
  resize: vertical;
  padding: 0.7rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1.45rem;
}

.prompt-code-textarea {
  resize: vertical;
  padding: 0.85rem;
  background: #f8fafc;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  line-height: 1.45rem;
}
.prompt-code-textarea.is-negative {
  border-color: #fed7aa;
  background: #fffaf5;
}
.prompt-code-textarea.is-negative:focus {
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.prompt-rule-textarea {
  min-height: 4.25rem;
  background: #fff;
}

.prompt-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.35rem;
  border-radius: 0.875rem;
  background: #f1f5f9;
  padding: 0.3rem;
}

.prompt-media-tab {
  display: inline-flex;
  min-height: 2.65rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid transparent;
  border-radius: 0.65rem;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
}
.prompt-media-tab:hover {
  color: #4338ca;
}
.prompt-media-tab.is-selected {
  border-color: #e0e7ff;
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.prompt-rules-details {
  width: 100%;
}

.prompt-history-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  text-align: left;
}
.prompt-history-row:hover, .prompt-history-row.is-selected {
  background: #f8fafc;
}

.prompt-history-version {
  display: inline-flex;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #f1f5f9;
  font-size: 0.6875rem;
  font-weight: 800;
  color: #475569;
}
.is-selected .prompt-history-version {
  background: #eef2ff;
  color: #4338ca;
}

@container page-prompts (min-width: 1024px) {
  .prompt-catalog-layout {
    grid-template-columns: 18rem minmax(0, 1fr);
  }
  .prompt-theme-panel {
    position: sticky;
    top: 1.25rem;
  }
}
@container page-prompts (max-width: 1023px) {
  .prompt-theme-panel > [role=group] {
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
  }
  .prompt-theme-panel > [role=group] > p {
    display: none;
  }
  .prompt-area-item {
    min-width: 13rem;
    flex: 0 0 auto;
  }
}
@container page-prompts (max-width: 639px) {
  .prompt-primary-button,
  .prompt-secondary-button,
  .prompt-delete-button {
    min-height: 2.5rem;
    padding-inline: 0.75rem;
  }
  .prompt-theme-list {
    display: flex;
    max-height: none;
    gap: 0.5rem;
    overflow-x: auto;
  }
  .prompt-theme-item {
    min-width: 15rem;
  }
  .prompt-draft-item {
    min-width: 15rem;
  }
  .prompt-media-tab {
    min-height: 2.5rem;
  }
  .prompt-expanded-backdrop {
    padding: 0;
  }
  .prompt-expanded-dialog {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border: 0;
    border-radius: 0;
  }
  .prompt-expanded-header,
  .prompt-expanded-footer {
    align-items: flex-start;
    padding: 0.875rem 1rem;
  }
  .prompt-expanded-footer {
    flex-direction: column;
  }
  .prompt-expanded-footer .prompt-primary-button {
    width: 100%;
  }
  .prompt-expanded-body {
    padding: 1rem;
  }
  .prompt-model-recipe > header {
    flex-direction: column;
  }
  .prompt-model-recipe > header button {
    width: 100%;
  }
  .prompt-expanded-fields {
    min-height: 34rem;
    grid-template-rows: minmax(18rem, 3fr) minmax(11rem, 2fr);
  }
  .prompt-expanded-fields.is-single {
    grid-template-rows: minmax(32rem, 1fr);
  }
}
@container page-prompts (max-width: 640px) {
  .prompt-criteria-modal-grid,
  .prompt-expanded-body {
    flex: 0 0 auto;
    overflow: visible;
  }
  .prompt-expanded-dialog {
    overflow-y: auto;
  }
}`],
})
export class PagePromptsComponent implements OnInit, OnDestroy {
    public criteriaMode: 'base' | 'legacy' = 'base';
    public criteriaLoading: boolean = true;
    public criteriaSaving: boolean = false;
    public criteriaError: string = '';
    public criteriaForm: any = null;
    public criteriaDefaults: any = null;
    public criteriaVersion: number = 0;
    public criteriaHistory: any[] = [];
    public criteriaSelectedKind: 'base' | 'scenario' | 'draft' = 'base';
    public criteriaSelectedScenario: any = null;
    public criteriaSelectedCut: any = null;
    public criteriaCuts: any[] = [];
    public criteriaCutsLoading: boolean = false;
    public criteriaCutsError: string = '';
    public criteriaDraftVersions: any[] = [];
    public criteriaDraftVersionsLoading: boolean = false;
    public criteriaDraftVersionsError: string = '';
    public criteriaDraftVersionsPage: number = 1;
    public criteriaDraftVersionsTotal: number = 0;
    private criteriaBrowseSequence: number = 0;
    private criteriaListSequence: number = 0;
    public criteriaDrafts: any[] = [];
    public criteriaDraftsTotal: number = 0;
    public criteriaDraftsPage: number = 1;
    public criteriaDraftsLoading: boolean = false;
    public criteriaDraftsError: string = '';
    public criteriaDraftQuery: string = '';
    public criteriaDraftScope: 'all' | 'mine' = 'all';
    public criteriaSelectedDraft: any = null;
    public criteriaSelectedIntensity: string = '3';
    public criteriaHistoryOpen: boolean = false;
    public criteriaViewedVersion: any = null;
    public criteriaHistoryRows: any[] = [];
    public criteriaHistoryTotal: number = 0;
    public criteriaHistoryPage: number = 1;
    public criteriaHistoryLoading: boolean = false;
    public criteriaHistoryError: string = '';
    public criteriaGenerationsOpen: boolean = false;
    public criteriaGenerationsLoading: boolean = false;
    public criteriaGenerations: any[] = [];
    public criteriaSelectedGeneration: any = null;
    public criteriaGenerationsError: string = '';
    private criteriaDialogReturnFocus: HTMLElement | null = null;
    public criteriaChangeSummary: string = '';
    public criteriaTab: 'intensity' | 'models' | 'consistency' | 'locale' = 'intensity';
    public criteriaExpression: 'realistic' | 'trigger' | 'blur' = 'realistic';
    public blurRules: any[] = [];
    public criteriaMedia: 'image' | 'audio' | 'video' = 'image';
    public criteriaEditing: boolean = false;
    private criteriaEditSnapshot: any = null;
    public criteriaSelectedModel: any = {
        image: 'openai-gpt-image-2',
        audio: 'clinical-soundscape-v1',
        video: 'kling-video-3'
    };
    public criteriaModelPickerOpen: boolean = false;
    private readonly criteriaModelPickerOutsideClickHandler = (event: MouseEvent) => {
        const target = event.target;
        if (!(target instanceof Element) || target.closest('.prompt-model-picker')) return;
        if (!this.criteriaModelPickerOpen) return;
        this.criteriaModelPickerOpen = false;
        void this.service.render();
    };
    public readonly criteriaVideoModels: any[] = [
        { value: 'kling-video-3', label: 'Kling AI · Video 3.0' },
        { value: 'evolink-seedance-2-5', label: 'Seedance 2.5' },
        { value: 'evolink-seedance-2-0-fast', label: 'Seedance 2.0 Fast' },
        { value: 'evolink-minimax-h3-max', label: 'MiniMax H3 Max' },
        { value: 'evolink-veo-3-1-fast', label: 'Veo 3.1 Fast' },
        { value: 'wan-2-2', label: 'Wan 2.2' }
    ];
    public readonly criteriaTabs: any[] = [
        { key: 'intensity', label: '강도 규칙', icon: 'fa-solid fa-sliders' },
        { key: 'models', label: '모델 설정', icon: 'fa-solid fa-wand-magic-sparkles' },
        { key: 'consistency', label: '시청각 일관성', icon: 'fa-solid fa-link' },
        { key: 'locale', label: '한국 시대·지역 규칙', icon: 'fa-solid fa-map-location-dot' }
    ];
    public readonly expressionOptions: any[] = [
        { key: 'realistic', label: '디테일 이미지', help: '확인된 장면을 사실적으로 묘사' },
        { key: 'trigger', label: '트리거 이미지', help: '확인된 트리거 요소에 시선 집중' },
        { key: 'blur', label: '블러 처리 이미지', help: '같은 기준 이미지·같은 영역에서 블러만 단계별로 감소' }
    ];
    public loading: boolean = true;
    public saving: boolean = false;
    public publishing: boolean = false;
    public deleting: boolean = false;
    public errorMessage: string = '';
    public sets: any[] = [];
    public canManage: boolean = false;
    public selectedKey: string = '';
    public selectedVersion: number = 0;
    public activeMedia: 'image' | 'audio' | 'video' = 'image';
    public activeArea: 'intensity' | 'locale' | 'consistency' | 'models' = 'intensity';
    public readonly areaOptions: any[] = [
        { value: 'intensity', title: '기억 강도 규칙', icon: 'fa-solid fa-sliders', summary: '1~5단계 기억 재현도' },
        { value: 'locale', title: '한국 시대·지역 규칙', icon: 'fa-solid fa-map-location-dot', summary: '시대·장소 표현 기준' },
        { value: 'consistency', title: '시청각 일관성', icon: 'fa-solid fa-link', summary: '장면·음향 연결 기준' },
        { value: 'models', title: '모델별 프롬프트', icon: 'fa-solid fa-wand-magic-sparkles', summary: '이미지·오디오·영상 모델' }
    ];
    public searchText: string = '';
    public searchStatus: string = '';
    public searchMediaType: string = '';
    public searchModel: string = '';
    public isNew: boolean = false;
    public cloneSource: any = null;
    public pendingDraft: any = null;
    public form: any = this.emptyForm();
    public referenceContext: any = null;
    public referenceContextApplied: boolean = false;
    public promptExpanded: boolean = false;
    private promptExpandedReturnFocus: HTMLElement | null = null;
    private readonly promptReferenceStorageKey = 'ptsd.referencePromptContext.v1';

    public readonly mediaTypes: any[] = [
        { value: 'image', label: '이미지', icon: 'fa-solid fa-image' },
        { value: 'audio', label: '오디오', icon: 'fa-solid fa-wave-square' },
        { value: 'video', label: '영상', icon: 'fa-solid fa-film' }
    ];
    public readonly intensityLevels: any[] = [
        { value: '1', label: '1 · 최소 재현' },
        { value: '2', label: '2 · 낮은 재현' },
        { value: '3', label: '3 · 중간 재현' },
        { value: '4', label: '4 · 높은 재현' },
        { value: '5', label: '5 · 최대 재현' }
    ];
    public readonly localeFields: any[] = [
        { key: 'era', label: '시대 규칙', icon: 'fa-solid fa-clock-rotate-left' },
        { key: 'region', label: '지역 규칙', icon: 'fa-solid fa-location-dot' },
        { key: 'guardrail', label: '시대착오 방지', icon: 'fa-solid fa-shield-halved' }
    ];
    public readonly consistencyFields: any[] = [
        { key: 'people', label: '인물', icon: 'fa-solid fa-user' },
        { key: 'background', label: '배경·장소', icon: 'fa-solid fa-mountain-city' },
        { key: 'vehicles', label: '차량·소품', icon: 'fa-solid fa-car-side' },
        { key: 'weather', label: '날씨', icon: 'fa-solid fa-cloud-sun' },
        { key: 'lighting', label: '조명', icon: 'fa-solid fa-lightbulb' },
        { key: 'audio', label: '음향 공간감', icon: 'fa-solid fa-volume-high' }
    ];
    private readonly imagePromptProfiles: any = {
        'openai-gpt-image-2': {
            format_title: '구체적인 제작 지시문형',
            format_summary: '원하는 결과를 목표부터 제약까지 자연어 문장으로 명확하게 작성합니다.',
            structure: ['목적·장면', '대상·행동', '구도·시점', '조명·색감', '보존·제외 조건'],
            example: '목표: 비가 그친 야간 도로의 기억 재현 장면. 승인된 차량 내부 시점과 공간 배치를 고정하고, 선택 단계의 확인 정보량과 초점 위계를 적용하며 식별 가능한 얼굴이나 읽을 수 있는 문자는 포함하지 않습니다.',
            starter_prompt: [
                '목표: {scenario_label}을 임상적으로 중립적인 기억 재현 이미지로 생성합니다.',
                '기억 재현도: 5단계 중 {intensity}단계({intensity_label})의 확인 정보량·시각적 주목도·묘사 밀도·초점 위계를 적용합니다.',
                '장면과 행동: 확인된 대상·행동·공간 관계만 반영하고 새로운 사실이나 자극을 추가하지 않습니다.',
                '구도와 시점: 모든 단계에서 승인된 카메라 위치·화각·프레이밍·공간 배치를 동일하게 유지합니다.',
                '조명과 색감: 환경과 시간대에 맞는 사실적인 광원, 절제된 색감과 재질을 사용합니다.',
                '제약: 식별 가능한 얼굴·개인정보·읽을 수 있는 문자·로고와 그래픽한 부상 표현은 포함하지 않습니다.'
            ].join('\n'),
            starter_negative: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 워터마크, 콜라주, 다중 패널, 그래픽한 부상, 피, 고어'
        },
        'evolink-seedream-5-lite': {
            format_title: '시각 구성 명세형',
            format_summary: '핵심 피사체와 공간 배치, 시각적 위계, 카메라와 분위기를 순서대로 지정합니다.',
            structure: ['핵심 피사체', '공간 배치', '시각적 위계', '카메라·렌즈', '분위기·재질'],
            example: '비가 갠 도심 도로, 승인된 차량 내부 시점과 공간 배치를 고정합니다. 선택 단계에 허용된 단서만 사용하고 시각적 주목도·재질 밀도·초점 위계로 기억 재현도를 구분합니다.',
            starter_prompt: [
                '{scenario_label}의 임상적으로 중립적인 기억 재현 장면.',
                '5단계 중 {intensity}단계({intensity_label})의 확인 정보량·시각적 주목도·묘사 밀도·초점 위계.',
                '핵심 피사체: 해당 단계에서 사용할 수 있는 확인된 대상과 행동만 사실적으로 표현합니다.',
                '공간 배치: 대상 사이의 거리·방향·위치를 일관되게 유지하고 한 장면 안에 자연스럽게 구성합니다.',
                '시각적 위계: 단계별 규칙에 따라 확인된 핵심 단서의 주목도와 초점만 조절합니다.',
                '카메라와 분위기: 모든 단계에서 승인된 카메라·화각·구도를 고정하고 현실적인 조명·날씨·표면 재질을 유지합니다.',
                '식별 가능한 사람·개인정보·읽을 수 있는 문자·로고·과도한 부상 묘사는 제외합니다.'
            ].join('\n'),
            starter_negative: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 워터마크, 콜라주, 다중 패널, 그래픽한 부상, 피, 고어'
        },
        'evolink-gemini-3-1-flash-image': {
            format_title: '자연어 작업 지시형',
            format_summary: '해야 할 일, 유지할 요소, 바꿀 요소와 금지 조건을 직접적인 문장으로 작성합니다.',
            structure: ['생성 목표', '반드시 유지', '구체 표현', '바꾸지 않음', '포함하지 않음'],
            example: '다음 기억 재현 이미지를 만드세요. 비가 그친 도로와 차량의 상대 위치, 승인된 카메라를 모든 단계에서 유지하세요. 확인되지 않은 사실이나 자극을 추가하지 마세요.',
            starter_prompt: [
                '다음 기억 재현 이미지를 만드세요.',
                '상황: {scenario_label}.',
                '기억 재현도: 5단계 중 {intensity}단계({intensity_label}); 확인 정보량·시각적 주목도·묘사 밀도·초점 위계만 조절합니다.',
                '반드시 유지: 승인된 대상, 행동, 공간의 상대 위치와 시간대·날씨의 일관성.',
                '구체 표현: 승인된 고정 시점과 구도, 자연스러운 조명과 재질의 하나의 장면.',
                '바꾸지 않음: 카메라·공간 배치·사건 유형을 바꾸거나 확인되지 않은 사실과 자극을 추가하지 않습니다.',
                '포함하지 않음: 식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 그래픽한 부상 표현.'
            ].join('\n'),
            starter_negative: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 워터마크, 콜라주, 다중 패널, 그래픽한 부상, 피, 고어'
        },
        'evolink-qwen-image-3': {
            format_title: '묘사 + 제외어 분리형',
            format_summary: 'Positive에는 원하는 장면을 구체적으로, Negative에는 원하지 않는 요소만 짧게 나눠 작성합니다.',
            structure: ['주제·장면', '공간·구도', '광원·색감', '사실성·스타일', 'Negative 제외어'],
            example: 'Positive: 비가 갠 야간 도로, 승인된 차량 내부 시점과 공간 배치, 선택 단계의 확인 정보와 초점 위계. Negative: 카메라 이동, 허구 정보, 자극 증가, 얼굴 식별, 문자, 로고, 콜라주.',
            starter_prompt: [
                '{scenario_label}, 임상적으로 중립적인 기억 재현 이미지.',
                '기억 재현도 5단계 중 {intensity}단계({intensity_label}), 해당 단계의 확인 정보량·시각적 주목도·묘사 밀도·초점 위계.',
                '승인된 핵심 대상과 행동, 고정된 카메라와 일관된 공간 관계, 안정된 단일 장면 구도.',
                '환경과 시간대에 맞는 사실적인 조명, 절제된 색감, 현실적인 표면 재질과 원근.'
            ].join('\n'),
            starter_negative: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 워터마크, 콜라주, 다중 패널, 왜곡된 구조, 그래픽한 부상, 피, 고어',
            negative_limit: 500
        },
        'evolink-grok-imagine-image-2': {
            format_title: '간결한 시네마틱 브리프형',
            format_summary: '한 장면의 주제와 행동, 카메라, 빛, 실패 조건을 짧고 선명하게 지정합니다.',
            structure: ['한 장면의 주제', '행동·환경', '카메라', '빛·분위기', '실패 조건'],
            example: '비가 갠 밤의 도로를 승인된 차량 내부 시점에서 본 사실적인 장면. 카메라와 공간 배치를 고정하고, 선택 단계의 확인 정보량과 초점 위계만 적용합니다. 문자·로고·식별 가능한 얼굴은 없습니다.',
            starter_prompt: [
                '{scenario_label}을 보여주는 하나의 사실적인 기억 재현 장면.',
                '기억 재현도는 5단계 중 {intensity}단계({intensity_label}); 확인 정보량·시각적 주목도·묘사 밀도·초점 위계만 조절합니다.',
                '확인된 대상과 행동, 주변 환경의 관계만 간결하고 분명하게 표현합니다.',
                '모든 단계에서 동일한 승인 카메라·화각·구도, 현실적인 원근과 환경에 맞는 빛.',
                '콜라주·다중 패널·식별 가능한 얼굴·개인정보·읽을 수 있는 문자·로고·그래픽한 부상은 없습니다.'
            ].join('\n'),
            starter_negative: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 워터마크, 콜라주, 다중 패널, 그래픽한 부상, 피, 고어'
        }
    };
    private readonly videoPromptProfiles: any = {
        'kling-v3': {
            format_title: '연속 동작 지시문형',
            format_summary: '첫 프레임을 기준으로 피사체 동작과 카메라 이동을 시간 순서로 작성합니다.',
            structure: ['시작 프레임 보존', '주요 동작', '카메라 이동', '장면 연속성', '제외 조건'],
            example: '승인된 첫 프레임의 차량과 도로 배치를 유지합니다. 카메라는 안정적으로 천천히 전진하고 커튼과 빗물만 자연스럽게 움직입니다. 새로운 사람·문자·로고는 만들지 않습니다.',
            starter_prompt: [
                '{scenario_label}의 승인된 원본 이미지를 짧은 치료 영상으로 자연스럽게 움직입니다.',
                '강도는 5단계 중 {intensity}단계({intensity_label})로 유지합니다.',
                '첫 프레임의 대상·배경·차량·날씨·조명과 공간 관계를 바꾸지 않습니다.',
                '하나의 연속된 숏에서 작은 환경 움직임과 안정적인 카메라 이동만 사용합니다.',
                '식별 가능한 얼굴·문자·로고·새로운 사건·그래픽한 부상은 추가하지 않습니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 불안정한 구조, 카메라 흔들림, 장면 전환, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
        },
        'seedance-2.5': {
            format_title: '장면·동작·사운드 통합형',
            format_summary: '장면 보존, 시간에 따른 움직임과 카메라를 하나의 프롬프트로 명시합니다.',
            structure: ['원본 보존', '시간 흐름', '대상 동작', '카메라', '제외 조건'],
            example: '원본 도로 장면과 차량 위치를 그대로 유지합니다. 5초 동안 빗물이 천천히 흐르고 카메라는 미세하게 앞으로 이동합니다. 인물이나 새로운 충돌 장면은 추가하지 않습니다.',
            starter_prompt: [
                '{scenario_label}의 승인된 첫 프레임을 기반으로 임상적으로 통제된 짧은 영상을 생성합니다.',
                '강도는 5단계 중 {intensity}단계({intensity_label})로 유지합니다.',
                '원본의 구도·대상·공간 관계·시간대·날씨·조명을 끝까지 보존합니다.',
                '동작은 작고 자연스럽게 연결하고 카메라는 안정적인 단일 숏으로 유지합니다.',
                '식별 가능한 사람·개인정보·문자·로고·새로운 외상 사건·그래픽한 부상은 만들지 않습니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 구조 왜곡, 장면 전환, 과도한 카메라 움직임, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
        },
        'seedance-2.0-fast': {
            format_title: '빠른 동작 초안형',
            format_summary: '초안 비교에 필요한 핵심 움직임과 보존 조건을 짧고 직접적으로 작성합니다.',
            structure: ['원본 보존', '핵심 동작', '카메라', '속도', '제외 조건'],
            example: '첫 프레임을 유지하고 커튼만 천천히 흔들리게 합니다. 고정된 눈높이 카메라, 하나의 연속된 숏, 새 인물과 문자는 없습니다.',
            starter_prompt: [
                '{scenario_label}, 강도 {intensity}/5({intensity_label})의 승인된 첫 프레임을 유지합니다.',
                '핵심 대상과 배경의 형태·위치·색을 바꾸지 않고 작은 자연스러운 움직임만 추가합니다.',
                '카메라는 안정적으로 유지하고 하나의 연속된 숏으로 생성합니다.',
                '새로운 인물·사건·문자·로고·그래픽한 부상은 추가하지 않습니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 구조 왜곡, 장면 전환, 카메라 흔들림, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
        },
        'minimax-h3-max': {
            format_title: '키프레임 모션 설계형',
            format_summary: '첫 프레임에서 유지할 요소와 프레임 사이의 움직임을 분명하게 지정합니다.',
            structure: ['첫 프레임', '유지 요소', '동작 궤적', '카메라', '종료 상태'],
            example: '첫 프레임의 실내 구조와 조명을 고정합니다. 커튼이 오른쪽으로 천천히 움직이고 카메라는 매우 느리게 줌인한 뒤 같은 구도로 끝납니다.',
            starter_prompt: [
                '{scenario_label}의 승인된 첫 프레임에서 시작합니다.',
                '강도는 5단계 중 {intensity}단계({intensity_label})로 유지합니다.',
                '대상 형태·배경 구조·공간 관계·조명을 보존하며 작은 동작의 방향과 속도를 자연스럽게 연결합니다.',
                '카메라는 안정적인 단일 숏으로 움직이고 마지막까지 동일한 장면 정체성을 유지합니다.',
                '새로운 사람·문자·로고·사건·그래픽한 부상은 생성하지 않습니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 형태 변형, 배경 재구성, 장면 전환, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
        },
        'veo-3.1-fast': {
            format_title: '시네마틱 단일 숏형',
            format_summary: '한 숏의 피사체, 동작, 카메라와 빛을 구체적으로 정의하고 편집 전환을 제한합니다.',
            structure: ['장면 정체성', '피사체 동작', '카메라·렌즈', '조명·질감', '종료 구도'],
            example: '승인된 야간 도로 장면의 사실적인 단일 숏. 젖은 노면 반사는 미세하게 움직이고 카메라는 운전자 눈높이에서 천천히 전진한 뒤 원래 구도를 유지하며 끝납니다.',
            starter_prompt: [
                '{scenario_label}의 승인된 이미지를 사실적인 시네마틱 단일 숏으로 움직입니다.',
                '강도는 5단계 중 {intensity}단계({intensity_label})로 유지합니다.',
                '원본 대상과 공간 관계를 보존하고 자연스러운 물리 움직임만 추가합니다.',
                '안정된 눈높이 카메라, 절제된 이동, 환경에 맞는 빛과 현실적인 표면 질감을 유지합니다.',
                '컷 전환·새 인물·문자·로고·새 사건·그래픽한 부상은 포함하지 않습니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 비현실적 물리, 장면 전환, 과도한 카메라 움직임, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
        },
        'wan-2.2': {
            format_title: 'Positive + Negative 분리형',
            format_summary: 'Positive에는 원하는 움직임을, Negative에는 시간축 왜곡과 금지 요소를 분리합니다.',
            structure: ['원본 장면', '주요 동작', '카메라', '연속성', 'Negative 제외어'],
            example: 'Positive: 첫 프레임의 도로와 차량 배치를 유지하며 빗물만 자연스럽게 움직이는 안정된 단일 숏. Negative: 프레임 떨림, 형태 변형, 새 인물, 문자, 로고.',
            starter_prompt: [
                '{scenario_label}의 승인된 원본 이미지를 임상적으로 중립적인 짧은 영상으로 생성합니다.',
                '강도는 5단계 중 {intensity}단계({intensity_label})로 유지합니다.',
                '대상·배경·공간 관계를 보존하며 작은 자연스러운 동작과 안정적인 카메라만 사용합니다.'
            ].join('\n'),
            starter_negative: '정체성 변화, 새로운 인물, 형태 변형, 프레임 떨림, 장면 전환, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어',
            negative_limit: 1800
        }
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        document.addEventListener('click', this.criteriaModelPickerOutsideClickHandler);
        this.loadReferenceContext();
        if (this.referenceContext) this.criteriaMode = 'legacy';
        await this.loadCriteria();
        await this.loadCriteriaDrafts();
        if (this.referenceContext) await this.load();
        else this.loading = false;
    }

    public async loadCriteria() {
        this.criteriaLoading = true;
        this.criteriaError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('criteria_bootstrap', {});
            if (code !== 200) {
                this.criteriaError = data?.message || '기본 생성 기준을 불러오지 못했습니다.';
                return;
            }
            this.criteriaDefaults = data.defaults;
            this.blurRules = data.blur_rules?.levels || [];
            this.criteriaForm = JSON.parse(JSON.stringify(data.active?.payload || data.defaults));
            this.canManage = data.can_manage === true;
            this.criteriaVersion = Number(data.active?.version || 0);
            this.criteriaHistory = Array.isArray(data.history) ? data.history : [];
            this.criteriaChangeSummary = '';
            this.criteriaEditing = false;
            this.criteriaEditSnapshot = null;
        } catch (_error) {
            this.criteriaError = '기본 생성 기준을 불러오지 못했습니다.';
        } finally {
            this.criteriaLoading = false;
            await this.service.render();
        }
    }

    public async refreshCriteriaPage() {
        if (this.criteriaMode === 'legacy') await this.load();
        else {
            await this.loadCriteria();
            await this.loadCriteriaDrafts();
        }
    }

    public async loadCriteriaDrafts(page: number = this.criteriaDraftsPage) {
        const sequence = ++this.criteriaListSequence;
        this.criteriaDraftsLoading = true;
        this.criteriaDraftsError = '';
        try {
            const { code, data } = await wiz.call('scenario_workbench_scenarios', {
                page, q: this.criteriaDraftQuery, scope: this.criteriaDraftScope
            });
            if (sequence !== this.criteriaListSequence) return;
            if (code !== 200) throw new Error(data?.message || '시나리오 작업본을 불러오지 못했습니다.');
            this.criteriaDrafts = Array.isArray(data?.rows) ? data.rows : [];
            this.criteriaDraftsTotal = Number(data?.total || 0);
            this.criteriaDraftsPage = Number(data?.page || page);
            if (this.criteriaSelectedScenario) {
                const current = this.criteriaDrafts.find((row: any) => row.scenario_id === this.criteriaSelectedScenario.scenario_id);
                if (!current) this.selectCriteriaBase();
                else await this.selectCriteriaScenario(current);
            }
        } catch (error) {
            if (sequence !== this.criteriaListSequence) return;
            this.criteriaDraftsError = String((error as Error)?.message || '시나리오 작업본을 불러오지 못했습니다.');
        } finally {
            if (sequence === this.criteriaListSequence) {
                this.criteriaDraftsLoading = false;
                await this.service.render();
            }
        }
    }

    public async searchCriteriaDrafts() {
        await this.loadCriteriaDrafts(1);
    }

    public async setCriteriaDraftScope(scope: 'all' | 'mine') {
        this.selectCriteriaBase();
        this.criteriaDraftScope = scope;
        await this.loadCriteriaDrafts(1);
    }

    public criteriaDraftsPageCount() {
        return Math.max(1, Math.ceil(this.criteriaDraftsTotal / 30));
    }

    public criteriaHistoryPageCount() {
        return Math.max(1, Math.ceil(this.criteriaHistoryTotal / 20));
    }

    public selectCriteriaBase() {
        this.resetCriteriaBrowser('base');
    }

    public selectCriteriaScenarioList() {
        this.resetCriteriaBrowser('scenario');
    }

    private resetCriteriaBrowser(kind: 'base' | 'scenario') {
        if (this.criteriaEditing) return;
        this.criteriaModelPickerOpen = false;
        this.criteriaSelectedKind = kind;
        this.criteriaSelectedDraft = null;
        this.criteriaSelectedScenario = null;
        this.criteriaSelectedCut = null;
        this.criteriaCuts = [];
        this.criteriaDraftVersions = [];
        this.criteriaCutsLoading = false;
        this.criteriaDraftVersionsLoading = false;
        this.criteriaCutsError = '';
        this.criteriaDraftVersionsError = '';
        this.criteriaBrowseSequence++;
        void this.service.render();
    }

    public selectCriteriaDraft(draft: any) {
        if (this.criteriaEditing || !draft) return;
        if (draft.scenario_id !== this.criteriaSelectedScenario?.scenario_id
            || draft.memory_kind !== this.criteriaSelectedCut?.memory_kind
            || draft.cut_order !== this.criteriaSelectedCut?.cut_order) return;
        const sameCut = this.criteriaSelectedDraft?.scenario_id === draft.scenario_id
            && this.criteriaSelectedDraft?.memory_kind === draft.memory_kind
            && this.criteriaSelectedDraft?.cut_order === draft.cut_order;
        this.criteriaModelPickerOpen = false;
        this.criteriaSelectedKind = 'draft';
        this.criteriaSelectedDraft = draft;
        if (!sameCut) this.criteriaSelectedIntensity = '3';
        void this.service.render();
    }

    public async selectCriteriaScenario(scenario: any) {
        if (this.criteriaEditing || !scenario) return;
        const sequence = ++this.criteriaBrowseSequence;
        this.criteriaSelectedKind = 'scenario';
        this.criteriaSelectedScenario = scenario;
        this.criteriaSelectedCut = null;
        this.criteriaSelectedDraft = null;
        this.criteriaCuts = [];
        this.criteriaCutsError = '';
        this.criteriaCutsLoading = true;
        this.criteriaDraftVersions = [];
        this.criteriaModelPickerOpen = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('scenario_workbench_cuts', {
                scenario_id: scenario.scenario_id, scope: this.criteriaDraftScope
            });
            if (sequence !== this.criteriaBrowseSequence) return;
            if (code !== 200) throw new Error(data?.message || '컷 목록을 불러오지 못했습니다.');
            this.criteriaCuts = Array.isArray(data?.rows) ? data.rows : [];
        } catch (error) {
            if (sequence === this.criteriaBrowseSequence) this.criteriaCutsError = String((error as Error)?.message || '컷 목록을 불러오지 못했습니다.');
        } finally {
            if (sequence === this.criteriaBrowseSequence) {
                this.criteriaCutsLoading = false;
                await this.service.render();
            }
        }
    }

    public criteriaCutLabel(cut: any) {
        return Number(cut?.cut_order) === 0 ? '공통 설정' : `컷 ${cut?.cut_order}`;
    }

    public async selectCriteriaCut(cut: any) {
        if (!cut || !this.criteriaSelectedScenario || cut.scenario_id !== this.criteriaSelectedScenario.scenario_id) return;
        this.criteriaSelectedCut = cut;
        this.criteriaSelectedKind = 'scenario';
        this.criteriaSelectedDraft = null;
        await this.loadCriteriaDraftVersions(1);
    }

    public async loadCriteriaDraftVersions(page: number = 1) {
        const scenario = this.criteriaSelectedScenario, cut = this.criteriaSelectedCut;
        if (!scenario || !cut) return;
        const sequence = ++this.criteriaBrowseSequence;
        this.criteriaDraftVersionsLoading = true;
        this.criteriaDraftVersionsError = '';
        this.criteriaDraftVersions = [];
        this.criteriaSelectedDraft = null;
        this.criteriaSelectedKind = 'scenario';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('scenario_workbench_draft_versions', {
                scenario_id: scenario.scenario_id, memory_kind: cut.memory_kind,
                cut_order: cut.cut_order, page, scope: this.criteriaDraftScope
            });
            if (sequence !== this.criteriaBrowseSequence) return;
            if (code !== 200) throw new Error(data?.message || '프롬프트 버전을 불러오지 못했습니다.');
            this.criteriaDraftVersions = Array.isArray(data?.rows) ? data.rows : [];
            this.criteriaDraftVersionsTotal = Number(data?.total || 0);
            this.criteriaDraftVersionsPage = Number(data?.page || page);
            if (this.criteriaDraftVersions.length) this.selectCriteriaDraft(this.criteriaDraftVersions[0]);
        } catch (error) {
            if (sequence === this.criteriaBrowseSequence) this.criteriaDraftVersionsError = String((error as Error)?.message || '프롬프트 버전을 불러오지 못했습니다.');
        } finally {
            if (sequence === this.criteriaBrowseSequence) {
                this.criteriaDraftVersionsLoading = false;
                await this.service.render();
            }
        }
    }

    public criteriaDraftVersionsPageCount() {
        return Math.max(1, Math.ceil(this.criteriaDraftVersionsTotal / 20));
    }

    public criteriaDraftIntensityText() {
        const draft = this.criteriaSelectedDraft?.draft || {};
        if (this.criteriaExpression === 'realistic') {
            return String(draft.intensities?.[this.criteriaSelectedIntensity] || '');
        }
        return String(draft.expression_intensities?.[this.criteriaExpression]?.[this.criteriaSelectedIntensity] || '');
    }

    public criteriaDraftTriggerElements(): string[] {
        const values = this.criteriaSelectedDraft?.draft?.trigger_elements;
        return Array.isArray(values) ? values.filter((value: any) => typeof value === 'string') : [];
    }

    public criteriaDraftModelText() {
        return String(this.criteriaSelectedDraft?.draft?.models?.[this.criteriaSelectedModel[this.criteriaMedia]] || '');
    }

    public criteriaDraftEditQuery() {
        const draft = this.criteriaSelectedDraft;
        return draft ? {
            source: 'scenario', scenario: draft.scenario_id,
            memory: draft.memory_kind
        } : {};
    }

    public async openCriteriaHistory(event?: Event) {
        this.criteriaDialogReturnFocus = event?.currentTarget instanceof HTMLElement
            ? event.currentTarget : document.activeElement instanceof HTMLElement
                ? document.activeElement : null;
        this.criteriaViewedVersion = null;
        this.criteriaHistoryRows = [];
        this.criteriaHistoryTotal = 0;
        this.criteriaHistoryPage = 1;
        this.criteriaHistoryOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => document.getElementById('criteria-history-close')?.focus(), 0);
        await this.loadCriteriaVersions(1);
    }

    public async loadCriteriaVersions(page: number) {
        this.criteriaHistoryLoading = true;
        this.criteriaHistoryError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('criteria_versions', { page });
            if (code !== 200) throw new Error(data?.message || '기본 템플릿 이력을 불러오지 못했습니다.');
            this.criteriaHistoryRows = Array.isArray(data?.rows) ? data.rows : [];
            this.criteriaHistoryTotal = Number(data?.total || 0);
            this.criteriaHistoryPage = Number(data?.page || page);
            this.criteriaViewedVersion = this.criteriaHistoryRows[0] || null;
        } catch (error) {
            this.criteriaHistoryError = String((error as Error)?.message || '기본 템플릿 이력을 불러오지 못했습니다.');
        } finally {
            this.criteriaHistoryLoading = false;
            await this.service.render();
        }
    }

    public async closeCriteriaHistory() {
        this.criteriaHistoryOpen = false;
        this.criteriaViewedVersion = null;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.criteriaDialogReturnFocus;
        this.criteriaDialogReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public viewCriteriaVersion(version: any) {
        this.criteriaViewedVersion = version;
        void this.service.render();
    }

    public async reuseViewedCriteriaVersion() {
        const version = Number(this.criteriaViewedVersion?.version || 0);
        await this.closeCriteriaHistory();
        if (version) {
            this.selectCriteriaBase();
            await this.restoreCriteriaVersion(version);
        }
    }

    public async openCriteriaGenerations(event?: Event) {
        const draft = this.criteriaSelectedDraft;
        if (!draft) return;
        this.criteriaDialogReturnFocus = event?.currentTarget instanceof HTMLElement
            ? event.currentTarget : document.activeElement instanceof HTMLElement
                ? document.activeElement : null;
        this.criteriaGenerationsOpen = true;
        this.criteriaGenerationsLoading = true;
        this.criteriaGenerationsError = '';
        this.criteriaGenerations = [];
        this.criteriaSelectedGeneration = null;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => document.getElementById('criteria-generations-close')?.focus(), 0);
        try {
            const { code, data } = await wiz.call('scenario_workbench_generations', {
                scenario_id: draft.scenario_id, cut_order: draft.cut_order,
                user_id: draft.user_id, memory_kind: draft.memory_kind
            });
            if (code !== 200) throw new Error(data?.message || '생성 기록을 불러오지 못했습니다.');
            this.criteriaGenerations = Array.isArray(data?.rows) ? data.rows : [];
            this.criteriaSelectedGeneration = this.criteriaGenerations[0] || null;
        } catch (error) {
            this.criteriaGenerationsError = String((error as Error)?.message || '생성 기록을 불러오지 못했습니다.');
        } finally {
            this.criteriaGenerationsLoading = false;
            await this.service.render();
        }
    }

    public async closeCriteriaGenerations() {
        this.criteriaGenerationsOpen = false;
        this.criteriaSelectedGeneration = null;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.criteriaDialogReturnFocus;
        this.criteriaDialogReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onCriteriaDialogKeydown(event: KeyboardEvent, dialogId: string) {
        if (event.key === 'Escape') {
            event.preventDefault();
            if (dialogId === 'criteria-history-dialog') void this.closeCriteriaHistory();
            else void this.closeCriteriaGenerations();
            return;
        }
        if (event.key !== 'Tab') return;
        const dialog = document.getElementById(dialogId);
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
        )).filter((element) => element.offsetParent !== null);
        if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
        if (event.shiftKey && document.activeElement === focusable[0]) {
            event.preventDefault(); focusable[focusable.length - 1].focus();
        } else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
            event.preventDefault(); focusable[0].focus();
        }
    }

    public async setCriteriaMode(mode: 'base' | 'legacy') {
        if (mode !== 'base' && mode !== 'legacy') return;
        this.criteriaMode = mode;
        await this.service.render();
    }

    public async setCriteriaTab(tab: 'intensity' | 'models' | 'consistency' | 'locale') {
        if (!this.criteriaTabs.some((item: any) => item.key === tab)) return;
        this.criteriaModelPickerOpen = false;
        this.criteriaTab = tab;
        await this.service.render();
    }

    public async setCriteriaExpression(expression: 'realistic' | 'trigger' | 'blur') {
        if (!this.expressionOptions.some((item: any) => item.key === expression)) return;
        this.criteriaExpression = expression;
        await this.service.render();
    }

    public async setCriteriaIntensity(value: string) {
        if (!this.intensityLevels.some((level: any) => level.value === value)) return;
        this.criteriaSelectedIntensity = value;
        await this.service.render();
    }

    public async setCriteriaMedia(media: 'image' | 'audio' | 'video') {
        if (!this.mediaTypes.some((item: any) => item.value === media)) return;
        this.criteriaModelPickerOpen = false;
        this.criteriaMedia = media;
        await this.service.render();
    }

    public criteriaSelectedModelLabel() {
        const selected = this.criteriaSelectedModel[this.criteriaMedia];
        return this.criteriaModelOptions(this.criteriaMedia).find(
            (model: any) => model.value === selected
        )?.label || '모델을 선택해주세요';
    }

    public async toggleCriteriaModelPicker() {
        this.criteriaModelPickerOpen = !this.criteriaModelPickerOpen;
        await this.service.render();
    }

    public async closeCriteriaModelPicker() {
        if (!this.criteriaModelPickerOpen) return;
        this.criteriaModelPickerOpen = false;
        await this.service.render();
    }

    public async selectCriteriaModel(model: string) {
        if (!this.criteriaModelOptions(this.criteriaMedia).some(
            (option: any) => option.value === model
        )) return;
        this.criteriaSelectedModel[this.criteriaMedia] = model;
        this.criteriaModelPickerOpen = false;
        await this.service.render();
    }

    public selectedCriteriaExpression() {
        return this.expressionOptions.find((item: any) =>
            item.key === this.criteriaExpression
        ) || this.expressionOptions[0];
    }

    public async startCriteriaEdit() {
        if (!this.canManage || !this.criteriaForm || this.criteriaEditing) return;
        this.criteriaEditSnapshot = JSON.parse(JSON.stringify(this.criteriaForm));
        this.criteriaEditing = true;
        await this.service.render();
    }

    public async cancelCriteriaEdit() {
        if (!this.criteriaEditing) return;
        if (this.criteriaEditSnapshot) {
            this.criteriaForm = JSON.parse(JSON.stringify(this.criteriaEditSnapshot));
        }
        this.criteriaChangeSummary = '';
        this.criteriaEditing = false;
        this.criteriaEditSnapshot = null;
        await this.service.render();
    }

    public criteriaModelOptions(mediaType: string) {
        return mediaType === 'video'
            ? this.criteriaVideoModels
            : this.modelOptions(mediaType);
    }

    public async restoreCriteriaSection() {
        if (!this.canManage || !this.criteriaDefaults || !this.criteriaForm) return;
        const title = this.criteriaTabs.find((item: any) => item.key === this.criteriaTab)?.label || '';
        const confirmed = await this.service.modal.show({
            title: '기본 템플릿 적용',
            message: `${title}의 현재 입력 내용을 기본 템플릿으로 교체합니다. 저장 전까지 운영 기준에는 반영되지 않습니다.`,
            action: '기본 템플릿 적용',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;
        this.criteriaForm[this.criteriaTab] = JSON.parse(
            JSON.stringify(this.criteriaDefaults[this.criteriaTab])
        );
        await this.service.render();
    }

    public async restoreCriteriaVersion(version: number) {
        if (!this.canManage || !this.criteriaForm) return;
        const previous = this.criteriaHistory.find((item: any) =>
            Number(item.version) === Number(version)
        ) || this.criteriaHistoryRows.find((item: any) =>
            Number(item.version) === Number(version)
        );
        if (!previous) return;
        const confirmed = await this.service.modal.show({
            title: `v${version} 불러오기`,
            message: `v${version}의 네 영역을 편집 화면으로 불러옵니다. 운영 기준은 새 버전을 저장할 때 변경됩니다.`,
            action: '불러오기',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;
        if (!this.criteriaEditing) {
            this.criteriaEditSnapshot = JSON.parse(JSON.stringify(this.criteriaForm));
        }
        this.criteriaForm = JSON.parse(JSON.stringify(previous.payload));
        this.criteriaChangeSummary = `v${version} 기준 다시 적용`;
        this.criteriaEditing = true;
        await this.service.render();
    }

    public async saveCriteria() {
        if (!this.canManage || !this.criteriaForm || this.criteriaSaving) return;
        if (String(this.criteriaChangeSummary || '').trim().length < 3) {
            await this.service.modal.error('변경 내용을 3자 이상 입력해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '기본 생성 기준 저장',
            message: `네 영역의 기본 템플릿을 v${this.criteriaVersion + 1}로 저장합니다. 이전 버전은 보존됩니다.`,
            action: '템플릿 저장',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;
        this.criteriaSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('criteria_save', {
                payload: this.criteriaForm,
                base_version: this.criteriaVersion,
                change_summary: this.criteriaChangeSummary,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 201) {
                await this.service.modal.error(data?.message || '기본 생성 기준을 저장하지 못했습니다.');
                return;
            }
            await this.loadCriteria();
        } catch (_error) {
            await this.service.modal.error('기본 생성 기준을 저장하지 못했습니다.');
        } finally {
            this.criteriaSaving = false;
            await this.service.render();
        }
    }

    public ngOnDestroy() {
        this.criteriaBrowseSequence++;
        this.criteriaListSequence++;
        document.removeEventListener('click', this.criteriaModelPickerOutsideClickHandler);
        this.promptExpanded = false;
        this.criteriaHistoryOpen = false;
        this.criteriaGenerationsOpen = false;
        this.promptExpandedReturnFocus = null;
        document.body.style.overflow = '';
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    private emptyForm() {
        return {
            set_key: '',
            name: '',
            scenario_label: '',
            publish_now: false,
            change_summary: '',
            source: {},
            reference_contexts: [],
            media: {
                image: {
                    target_model: 'openai-gpt-image-2',
                    positive_prompt: '{scenario_label}의 임상적으로 중립적인 기억 재현 이미지를 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 확인 정보량·시각적 주목도·묘사 밀도·초점 위계를 적용합니다.',
                    negative_prompt: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
                },
                audio: {
                    target_model: 'clinical-soundscape-v1',
                    positive_prompt: '{scenario_label}의 임상적으로 중립적인 비언어 기억 재현 사운드스케이프를 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 확인 정보량과 묘사 밀도를 적용합니다.',
                    negative_prompt: '식별 가능한 목소리, 음성으로 말한 이름, 개인정보, 비명, 그래픽한 부상 설명'
                },
                video: {
                    target_model: 'wan-2.2',
                    positive_prompt: '{scenario_label}의 짧고 임상적으로 중립적인 기억 재현 영상을 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 확인 정보량·시각적 주목도·묘사 밀도·초점 위계를 적용합니다.',
                    negative_prompt: '정체성 변화, 불안정한 구조, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
                }
            },
            intensity_rules: {
                '1': '{patient_prompt}에서 넓은 상황과 확인된 일반 단서 하나만 반영합니다. 모든 단계에서 승인된 시점·화각·프레이밍·공간 배치를 유지하고 새로운 사실이나 자극을 추가하지 않습니다. 이미지·영상은 화면 전체에 깊고 고른 초점을 사용하며 남긴 단서는 단순한 윤곽, 낮은 국소 대비와 최소 질감으로 표현합니다.',
                '2': '{patient_prompt}에서 확인된 장소·행동 시작과 단서 1~2개를 반영합니다. 승인된 카메라와 공간 배치를 유지하고 미확인 세부는 비워 둡니다. 이미지·영상은 장면 전체를 읽을 수 있는 깊은 초점에서 핵심 단서에만 약한 우선순위를 주고 기본 재질과 절제된 반사를 사용합니다.',
                '3': '{patient_prompt}의 확인된 핵심 행동과 대표 단서 2~3개를 반영합니다. 승인된 시점·화각·구도는 유지하고 새로운 사실이나 자극을 만들지 않습니다. 이미지·영상은 표준 피사계 심도에서 전체 장면과 핵심 단서에 균형 있게 주목하며 자연스러운 재질, 반사와 거리 관계를 표현합니다.',
                '4': '{patient_prompt}에서 확인된 사람·장소·물체의 상대 위치, 행동과 감각 단서를 대부분 반영합니다. 카메라와 공간 배치는 유지합니다. 이미지·영상은 장면 전체가 또렷하게 읽히는 표준~깊은 초점을 사용하고 보케·단일 단서 고립·극단적 미세 질감 없이 재질, 반사, 접촉 그림자와 가림을 분명하게 표현합니다.',
                '5': '{patient_prompt}의 미디어 표현 가능한 확인 정보를 빠짐없이 반영하고 미확인 사실은 추가하지 않습니다. 승인된 시점·화각·프레이밍·공간 배치를 유지합니다. 이미지·영상은 확인된 핵심 단서 하나에만 뚜렷한 얕은 자연 피사계 심도와 가장 선명한 광학 초점을 적용하고 먼 비핵심 요소는 자연스러운 보케로 분리합니다. 해당 단서의 경계, 재질, 반사, 미세 구조와 국소 대비를 최고 정밀도로 표현합니다.'
            },
            locale_rules: {
                era: '선택한 한국 시대의 건축·도로·교통수단·생활 도구를 교차 확인합니다.',
                region: '선택한 지역의 지형·도시 구조·기후 단서를 과장 없이 반영합니다.',
                guardrail: '현대 표지판, 상표, 번호판, 식별 문구와 시대착오 요소를 제외합니다.'
            },
            consistency_rules: {
                people: '인물의 연령대·복장·위치·시선 방향을 장면 간 일관되게 유지합니다.',
                background: '장소의 구조, 동선, 주요 배경물의 상대 위치를 고정합니다.',
                vehicles: '차종·색상·진행 방향·손상 유무를 자산 간 일치시킵니다.',
                weather: '날씨·노면 상태·시간대를 이미지, 영상, 음향에 동일하게 적용합니다.',
                lighting: '광원 방향·색온도·노출 수준을 모든 시각 자산에 맞춥니다.',
                audio: '공간 크기·재질·거리감에 맞는 환경음과 잔향을 유지합니다.'
            }
        };
    }

    public async load(preferredKey: string = '', preferredVersion: number = 0) {
        const resumePendingDraft = this.isNew && !!this.pendingDraft && !preferredKey;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('bootstrap', {});
            if (code !== 200) {
                this.errorMessage = data?.message || '프롬프트 세트를 불러오지 못했습니다.';
                return;
            }
            this.sets = Array.isArray(data?.sets) ? data.sets : [];
            this.canManage = data?.can_manage === true;
            const key = preferredKey || this.selectedKey;
            const version = Number(preferredVersion || this.selectedVersion || 0);
            const preferred = this.sets.find((item: any) =>
                item.scenario_type === key && (!version || Number(item.version) === version)
            );
            const fallback = this.themeCards()[0] || null;
            if (resumePendingDraft) {
                this.selectDraft(false);
            } else if (preferred || fallback) {
                this.selectSet(preferred || fallback, false);
            } else if (this.canManage) {
                this.newSet(false);
            }
        } catch (_error) {
            this.errorMessage = '프롬프트 세트를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public themeCards() {
        const latest = new Map<string, any>();
        for (const item of this.sets) {
            const key = String(item?.scenario_type || '');
            const current = latest.get(key);
            if (!current || Number(item?.version || 0) > Number(current?.version || 0)) {
                latest.set(key, item);
            }
        }
        return Array.from(latest.values()).sort((a: any, b: any) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), 'ko')
        );
    }

    public areaTitle() {
        return this.areaOptions.find((area: any) => area.value === this.activeArea)?.title || '';
    }

    public editorTitle() {
        if (this.activeArea === 'intensity') return '기억 강도 프롬프트';
        return this.isNew ? this.pendingDraftName() : (this.form.name || '프롬프트 세트');
    }

    public editorSubtitle() {
        if (this.activeArea === 'intensity') {
            return '모든 시나리오에 공통으로 적용되는 기억 재현도 1~5단계 규칙입니다.';
        }
        return this.isNew
            ? '아직 저장되지 않은 임시 세트입니다.'
            : '저장하면 기존 내용을 덮어쓰지 않고 새 버전이 생성됩니다.';
    }

    public selectArea(area: 'intensity' | 'locale' | 'consistency' | 'models') {
        this.activeArea = area;
        void this.service.render();
    }

    public selectedContextKey() {
        return this.isNew ? '__draft__' : this.selectedKey;
    }

    public selectContext(value: string) {
        if (value === '__draft__') {
            this.selectDraft(false);
        } else {
            const selected = this.themeCards().find((item: any) => item.scenario_type === value);
            if (selected) this.selectSet(selected, false);
        }
        void this.service.render();
    }

    public hasSearchFilters() {
        return !!(
            String(this.searchText || '').trim()
            || this.searchStatus
            || this.searchMediaType
            || this.searchModel
        );
    }

    private searchableMedia(item: any) {
        const media = item?.media || {};
        if (this.searchMediaType) {
            return [media[this.searchMediaType]].filter(Boolean);
        }
        return Object.values(media || {});
    }

    public filteredPromptSets() {
        const keyword = String(this.searchText || '').trim().toLowerCase();
        const candidates = this.hasSearchFilters() ? this.sets : this.themeCards();
        return candidates.filter((item: any) => {
            if (this.searchStatus && String(item?.status || '') !== this.searchStatus) {
                return false;
            }
            const media = this.searchableMedia(item);
            if (this.searchMediaType && media.length === 0) return false;
            if (
                this.searchModel
                && !media.some((value: any) =>
                    String(value?.target_model || '') === this.searchModel
                )
            ) {
                return false;
            }
            if (!keyword) return true;
            const rules = [
                ...Object.values(item?.intensity_rules || {}),
                ...Object.values(item?.locale_rules || {}),
                ...Object.values(item?.consistency_rules || {})
            ];
            const values = [
                item?.name,
                item?.scenario_type,
                item?.scenario_label,
                item?.change_summary,
                item?.created_by_name,
                ...media.flatMap((value: any) => [
                    value?.positive_prompt,
                    value?.negative_prompt,
                    value?.target_model
                ]),
                ...rules
            ];
            return values.some((value: any) =>
                String(value || '').toLowerCase().includes(keyword)
            );
        }).sort((a: any, b: any) => {
            const byName = String(a?.name || '').localeCompare(
                String(b?.name || ''),
                'ko'
            );
            return byName || Number(b?.version || 0) - Number(a?.version || 0);
        });
    }

    public filteredThemes() {
        return this.filteredPromptSets();
    }

    public modelFilterOptions() {
        const models = new Set<string>();
        for (const item of this.sets) {
            for (const value of Object.values(item?.media || {}) as any[]) {
                const model = String(value?.target_model || '').trim();
                if (model) models.add(model);
            }
        }
        return Array.from(models).sort((a: string, b: string) => a.localeCompare(b));
    }

    public async clearSearch() {
        this.searchText = '';
        this.searchStatus = '';
        this.searchMediaType = '';
        this.searchModel = '';
        await this.service.render();
    }

    public versionsForSelected() {
        return this.sets
            .filter((item: any) => item.scenario_type === this.selectedKey)
            .sort((a: any, b: any) => Number(b.version || 0) - Number(a.version || 0));
    }

    public currentSet() {
        return this.sets.find((item: any) =>
            item.scenario_type === this.selectedKey
            && Number(item.version || 0) === Number(this.selectedVersion || 0)
        ) || null;
    }

    private stashCurrentDraft() {
        if (!this.isNew) return;
        const previous = this.pendingDraft || {};
        this.pendingDraft = {
            ...previous,
            form: this.form,
            cloneSource: this.cloneSource,
            activeMedia: this.activeMedia
        };
    }

    private activateDraft(
        form: any,
        cloneSource: any = null,
        render: boolean = true,
        returnSelection: any = null
    ) {
        this.isNew = true;
        this.selectedKey = '';
        this.selectedVersion = 0;
        this.activeMedia = 'image';
        this.cloneSource = cloneSource;
        this.form = form;
        this.pendingDraft = {
            form: this.form,
            cloneSource: this.cloneSource,
            activeMedia: this.activeMedia,
            returnKey: String(returnSelection?.scenario_type || ''),
            returnVersion: Number(returnSelection?.version || 0)
        };
        if (render) {
            void this.service.render();
            setTimeout(() => document.getElementById('prompt-set-name')?.focus(), 0);
        }
    }

    public pendingDraftName() {
        return String(this.pendingDraft?.form?.name || '').trim()
            || (this.pendingDraft?.cloneSource ? '복제 프롬프트 세트' : '이름 없는 새 프롬프트');
    }

    public selectDraft(render: boolean = true) {
        if (!this.pendingDraft) return;
        this.isNew = true;
        this.selectedKey = '';
        this.selectedVersion = 0;
        this.form = this.pendingDraft.form;
        this.cloneSource = this.pendingDraft.cloneSource || null;
        this.activeMedia = this.pendingDraft.activeMedia || 'image';
        if (render) {
            void this.service.render();
            setTimeout(() => document.getElementById('prompt-set-name')?.focus(), 0);
        }
    }

    public selectSet(item: any, render: boolean = true) {
        if (!item) return;
        this.stashCurrentDraft();
        this.isNew = false;
        this.selectedKey = String(item.scenario_type || '');
        this.selectedVersion = Number(item.version || 0);
        this.activeMedia = 'image';
        this.cloneSource = null;
        const defaults = this.emptyForm();
        const media: any = {};
        for (const definition of this.mediaTypes) {
            const value = item?.media?.[definition.value] || {};
            media[definition.value] = {
                target_model: this.normalizeTargetModel(
                    definition.value,
                    value.target_model || defaults.media[definition.value].target_model
                ),
                positive_prompt: value.positive_prompt || defaults.media[definition.value].positive_prompt,
                negative_prompt: value.negative_prompt || defaults.media[definition.value].negative_prompt
            };
        }
        this.form = {
            set_key: item.scenario_type || '',
            name: item.name || '',
            scenario_label: item.scenario_label || '',
            publish_now: false,
            change_summary: '',
            source: {
                scenario_type: item.scenario_type || '',
                version: Number(item.version || 0)
            },
            reference_contexts: Array.isArray(item.reference_contexts)
                ? item.reference_contexts.map((context: any) => ({ ...context }))
                : [],
            media,
            intensity_rules: { ...defaults.intensity_rules, ...(item.intensity_rules || {}) },
            locale_rules: { ...defaults.locale_rules, ...(item.locale_rules || {}) },
            consistency_rules: { ...defaults.consistency_rules, ...(item.consistency_rules || {}) }
        };
        if (this.pendingDraft) {
            this.pendingDraft.returnKey = this.selectedKey;
            this.pendingDraft.returnVersion = this.selectedVersion;
        }
        if (render) void this.service.render();
    }

    public selectVersion(item: any) {
        this.selectSet(item);
    }

    public newSet(render: boolean = true) {
        if (!this.canManage) return;
        this.activeArea = 'models';
        if (this.pendingDraft) {
            this.selectDraft(render);
            return;
        }
        const returnSelection = this.currentSet();
        const form = this.emptyForm();
        form.change_summary = '새 프롬프트 세트 초안 생성';
        this.activateDraft(form, null, render, returnSelection);
    }

    public async cloneSet(item: any = this.currentSet()) {
        if (!this.canManage || !item) return;
        if (this.pendingDraft) {
            const confirmed = await this.service.modal.show({
                title: '작성 중인 세트 바꾸기',
                message: '현재 작성 중인 새 프롬프트를 버리고 선택한 세트의 복제본으로 바꿉니다.',
                action: '복제본으로 바꾸기',
                actionBtn: 'warning',
                status: 'warning'
            });
            if (!confirmed) return;
        }
        const source = {
            scenario_type: String(item.scenario_type || ''),
            version: Number(item.version || 0),
            name: String(item.name || '')
        };
        this.selectSet(item, false);
        this.form.set_key = '';
        this.form.name = `${source.name} 복사본`.slice(0, 120);
        this.form.publish_now = false;
        this.form.change_summary = `${source.name} v${source.version}에서 복제`.slice(0, 255);
        this.form.source = {
            scenario_type: source.scenario_type,
            version: source.version
        };
        this.activateDraft(this.form, source, true, item);
    }

    public async discardDraft(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.pendingDraft) return;
        const confirmed = await this.service.modal.show({
            title: '작성 중인 세트 취소',
            message: '아직 저장하지 않은 새 프롬프트 세트를 삭제합니다.',
            action: '작성 취소',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        const wasSelected = this.isNew;
        const returnKey = String(this.pendingDraft.returnKey || '');
        const returnVersion = Number(this.pendingDraft.returnVersion || 0);
        this.pendingDraft = null;
        if (wasSelected) {
            this.isNew = false;
            const returnSet = this.sets.find((item: any) =>
                item.scenario_type === returnKey
                && Number(item.version || 0) === returnVersion
            ) || this.themeCards()[0] || null;
            if (returnSet) {
                this.selectSet(returnSet, false);
            } else {
                this.selectedKey = '';
                this.selectedVersion = 0;
                this.cloneSource = null;
                this.form = this.emptyForm();
            }
        }
        await this.service.render();
    }

    public selectMedia(mediaType: 'image' | 'audio' | 'video') {
        this.activeMedia = mediaType;
        if (this.isNew && this.pendingDraft) {
            this.pendingDraft.activeMedia = mediaType;
        }
        void this.service.render();
    }

    public onTargetModelChange(_mediaType: string) {
        // Keep both stored prompt fields intact while the selected model's
        // input contract determines which editor controls are visible.
        void this.service.render();
    }

    public async openPromptExpanded(event?: Event) {
        if (this.promptExpanded) return;
        this.promptExpandedReturnFocus = event?.currentTarget instanceof HTMLElement
            ? event.currentTarget
            : (document.activeElement instanceof HTMLElement ? document.activeElement : null);
        this.promptExpanded = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            const target = this.canManage
                ? document.getElementById('prompt-expanded-positive')
                : document.getElementById('prompt-expanded-close');
            target?.focus();
        }, 0);
    }

    public async closePromptExpanded() {
        if (!this.promptExpanded) return;
        this.promptExpanded = false;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.promptExpandedReturnFocus;
        this.promptExpandedReturnFocus = null;
        setTimeout(() => {
            if (target?.isConnected) {
                target.focus();
            } else {
                document.getElementById('prompt-expand-trigger')?.focus();
            }
        }, 0);
    }

    public onPromptExpandedKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closePromptExpanded();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('prompt-expanded-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (!focusable.length) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    private cleanReferenceValue(value: any, maximum: number = 120) {
        return String(value || '')
            .replace(/[\u0000-\u001f\u007f]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, maximum);
    }

    private loadReferenceContext() {
        let parsed: any = null;
        try {
            parsed = JSON.parse(
                window.sessionStorage.getItem(this.promptReferenceStorageKey) || 'null'
            );
        } catch (_error) {
            parsed = null;
        }
        if (!parsed || Number(parsed?.schema_version || 0) !== 1) return;
        this.referenceContext = {
            reference_id: this.cleanReferenceValue(parsed.reference_id, 64),
            title: this.cleanReferenceValue(parsed.title, 255),
            source_label: this.cleanReferenceValue(parsed.source_label),
            source_url: this.cleanReferenceUrl(parsed.source_url),
            source_credit: this.cleanReferenceValue(parsed.source_credit, 255),
            era_label: this.cleanReferenceValue(parsed.era_label, 80),
            region: this.cleanReferenceValue(parsed.region, 80),
            district: this.cleanReferenceValue(parsed.district, 80),
            category: this.cleanReferenceValue(parsed.category)
        };
        this.activeArea = 'locale';
    }

    public referenceContextSummary() {
        return this.referenceSummary(this.referenceContext);
    }

    public referenceSummary(context: any) {
        if (!context) return '';
        const values = [
            context.era_label,
            context.region,
            context.district,
            context.category
        ].filter((value: string, index: number, items: string[]) =>
            !!value && value !== '연대 미상' && items.indexOf(value) === index
        );
        return values.join(' · ') || '분류된 시대·지역 정보가 없습니다.';
    }

    private cleanReferenceUrl(value: any) {
        const text = this.cleanReferenceValue(value, 1000);
        return /^https?:\/\//i.test(text) ? text : '';
    }

    private appendRule(current: any, addition: string, maximum: number = 500) {
        const original = String(current || '').trim();
        if (!addition || original.includes(addition)) return original;
        return [original, addition].filter(Boolean).join('\n').slice(0, maximum);
    }

    public async applyReferenceContext() {
        if (!this.canManage || !this.referenceContext || this.referenceContextApplied) return;
        const era = this.referenceContext.era_label && this.referenceContext.era_label !== '연대 미상'
            ? `레퍼런스 메타데이터 기준 촬영·생산 시대는 ${this.referenceContext.era_label}입니다. 해당 시대의 일반적인 건축·교통·생활 도구 특징만 반영합니다.`
            : '';
        const place = [
            this.referenceContext.region,
            this.referenceContext.district,
            this.referenceContext.category
        ].filter(Boolean).join(' · ');
        const region = place
            ? `레퍼런스 메타데이터 기준 지역·분류는 ${place}입니다. 해당 지역의 일반적인 지형·도시 구조·기후 단서만 반영합니다.`
            : '';
        const guardrail = '원본 이미지 파일은 생성 모델에 전달하지 않으며 특정 구도·인물·문구·고유 표현을 재현하지 않습니다.';
        this.form.locale_rules.era = this.appendRule(this.form.locale_rules.era, era);
        this.form.locale_rules.region = this.appendRule(this.form.locale_rules.region, region);
        this.form.locale_rules.guardrail = this.appendRule(
            this.form.locale_rules.guardrail,
            guardrail
        );
        const contexts = Array.isArray(this.form.reference_contexts)
            ? this.form.reference_contexts
            : [];
        const duplicate = contexts.some((context: any) =>
            String(context?.reference_id || '') === String(this.referenceContext.reference_id || '')
            && String(context?.source_url || '') === String(this.referenceContext.source_url || '')
        );
        if (!duplicate) {
            this.form.reference_contexts = [...contexts, { ...this.referenceContext }];
        }
        const source = this.referenceContext.source_label || '공공 아카이브';
        this.form.change_summary = `레퍼런스 메타데이터 반영: ${source}`.slice(0, 255);
        this.referenceContextApplied = true;
        this.activeArea = 'locale';
        try {
            window.sessionStorage.removeItem(this.promptReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    public async dismissReferenceContext() {
        this.referenceContext = null;
        this.referenceContextApplied = false;
        this.criteriaMode = 'base';
        try {
            window.sessionStorage.removeItem(this.promptReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    public modelOptions(mediaType: string) {
        if (mediaType === 'image') {
            return [
                { value: 'openai-gpt-image-2', label: 'OpenAI · GPT Image 2.5 Sunburst', prompt_mode: 'single' },
                { value: 'evolink-seedream-5-lite', label: 'Seedream 5.0 Lite', prompt_mode: 'single' },
                { value: 'evolink-gemini-3-1-flash-image', label: 'Gemini 3.1 Flash Image', prompt_mode: 'single' },
                { value: 'evolink-qwen-image-3', label: 'Qwen Image 3.0', prompt_mode: 'split' },
                { value: 'evolink-grok-imagine-image-2', label: 'Grok Imagine Image 2.0', prompt_mode: 'single' }
            ];
        }
        if (mediaType === 'video') {
            return [
                { value: 'kling-v3', label: 'Kling · Video 3.0', prompt_mode: 'single' },
                { value: 'seedance-2.5', label: 'Seedance 2.5', prompt_mode: 'single' },
                { value: 'seedance-2.0-fast', label: 'Seedance 2.0 Fast', prompt_mode: 'single' },
                { value: 'minimax-h3-max', label: 'MiniMax H3 Max', prompt_mode: 'single' },
                { value: 'veo-3.1-fast', label: 'Veo 3.1 Fast', prompt_mode: 'single' },
                { value: 'wan-2.2', label: 'Wan 2.2', prompt_mode: 'split' }
            ];
        }
        return [
            { value: 'clinical-soundscape-v1', label: 'Clinical Soundscape v1' },
            { value: 'openai-gpt-audio', label: 'OpenAI · GPT Audio' }
        ];
    }

    private selectedModelOption(mediaType: string) {
        const selected = String(
            this.form?.media?.[mediaType]?.target_model || ''
        ).trim();
        return this.modelOptions(mediaType).find(
            (item: any) => item.value === selected
        ) || null;
    }

    public modelPromptProfile(mediaType: string) {
        const selected = String(
            this.form?.media?.[mediaType]?.target_model || ''
        ).trim();
        if (mediaType === 'image') return this.imagePromptProfiles[selected] || null;
        if (mediaType === 'video') return this.videoPromptProfiles[selected] || null;
        return null;
    }

    public recommendedPromptApplied(mediaType: string) {
        const profile = this.modelPromptProfile(mediaType);
        const media = this.form?.media?.[mediaType];
        if (!profile || !media) return false;
        return String(media.positive_prompt || '').trim() === profile.starter_prompt
            && String(media.negative_prompt || '').trim() === profile.starter_negative;
    }

    public async applyRecommendedPromptTemplate(mediaType: string) {
        if (!this.canManage) return;
        const profile = this.modelPromptProfile(mediaType);
        const media = this.form?.media?.[mediaType];
        const model = this.selectedModelOption(mediaType);
        if (!profile || !media || this.recommendedPromptApplied(mediaType)) return;
        const confirmed = await this.service.modal.show({
            title: '권장 템플릿 적용',
            message: `${model?.label || '선택 모델'}에 맞는 권장 템플릿으로 현재 프롬프트 내용을 교체합니다. 새 버전을 저장하기 전까지 서버에는 반영되지 않습니다.`,
            action: '템플릿 적용',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;
        media.positive_prompt = profile.starter_prompt;
        media.negative_prompt = profile.starter_negative;
        await this.service.render();
        setTimeout(() => {
            if (this.promptExpanded) {
                document.getElementById('prompt-expanded-positive')?.focus();
            }
        }, 0);
    }

    public promptInputMode(mediaType: string) {
        return this.selectedModelOption(mediaType)?.prompt_mode === 'single'
            ? 'single'
            : 'split';
    }

    public usesSeparateNegativePrompt(mediaType: string) {
        return this.promptInputMode(mediaType) === 'split';
    }

    public promptInputModeLabel(mediaType: string) {
        return this.usesSeparateNegativePrompt(mediaType)
            ? 'Positive + Negative 분리 입력'
            : '단일 프롬프트 입력';
    }

    public primaryPromptLabel(mediaType: string) {
        return this.usesSeparateNegativePrompt(mediaType)
            ? 'Positive 프롬프트'
            : '프롬프트';
    }

    public promptInputGuide(mediaType: string) {
        if (this.usesSeparateNegativePrompt(mediaType)) {
            return mediaType === 'image'
                ? '이 모델은 prompt와 negative_prompt를 각각 지원해 두 입력을 분리하여 전달합니다.'
                : '이 모델은 Positive와 Negative 입력을 각각 관리합니다.';
        }
        return '이 모델은 하나의 prompt 입력을 사용합니다. 아래 본문과 기존 안전 제외 조건을 생성 요청에서 하나로 결합합니다.';
    }

    public negativePromptMaxLength(mediaType: string) {
        return Number(this.modelPromptProfile(mediaType)?.negative_limit || 1800);
    }

    private normalizeTargetModel(mediaType: string, value: any) {
        const model = String(value || '').trim();
        if (mediaType !== 'image') return model;
        const legacyAliases: any = {
            'gpt-image-2': 'openai-gpt-image-2',
            'seedream-4.0': 'evolink-seedream-5-lite'
        };
        return legacyAliases[model] || model;
    }

    public unsupportedTargetModelValue(mediaType: string) {
        const model = String(this.form?.media?.[mediaType]?.target_model || '').trim();
        if (!model) return '';
        return this.modelOptions(mediaType).some((item: any) => item.value === model)
            ? ''
            : model;
    }

    public mediaLabel(mediaType: string) {
        return this.mediaTypes.find((item: any) => item.value === mediaType)?.label || mediaType;
    }

    public mediaIcon(mediaType: string) {
        return this.mediaTypes.find((item: any) => item.value === mediaType)?.icon || 'fa-solid fa-file';
    }

    public statusLabel(status: string) {
        const labels: any = {
            active: '활성',
            draft: '초안',
            archived: '보관',
            queued: '대기',
            running: '생성 중',
            postprocessing: '후처리',
            review_pending: '검수 대기',
            approved: '승인',
            rejected: '반려',
            failed: '실패',
            cancelled: '취소',
            quarantined: '격리'
        };
        return labels[status] || status || '-';
    }

    public resultStatusClass(status: string) {
        if (status === 'approved') return 'bg-emerald-50 text-emerald-700';
        if (status === 'failed' || status === 'rejected') return 'bg-rose-50 text-rose-700';
        if (status === 'running' || status === 'postprocessing') return 'bg-blue-50 text-blue-700';
        if (status === 'review_pending') return 'bg-amber-50 text-amber-700';
        return 'bg-slate-100 text-slate-600';
    }

    public lineageLabel(item: any) {
        if (!item?.source) return '최초 생성';
        const action = item?.lineage_action === 'cloned' ? '복제' : '수정';
        return `${item.source.name || item.source.scenario_type} v${item.source.version}에서 ${action}`;
    }

    public resultParameterSummary(result: any) {
        const parameters = result?.parameters || {};
        const values: string[] = [];
        if (parameters.intensity) values.push(`강도 ${parameters.intensity}`);
        if (parameters.candidate_count) {
            const position = parameters.candidate_index
                ? ` ${parameters.candidate_index}/${parameters.candidate_count}`
                : ` ${parameters.candidate_count}개`;
            values.push(`후보${position}`);
        }
        if (parameters.video_duration_seconds) {
            values.push(`${parameters.video_duration_seconds}초`);
        }
        for (const key of ['resolution', 'aspect_ratio', 'quality', 'fps', 'seed']) {
            if (parameters[key] !== undefined && parameters[key] !== '') {
                values.push(`${key} ${parameters[key]}`);
            }
        }
        return values.join(' · ') || '기본 파라미터';
    }

    public date(value: any) {
        const text = String(value || '');
        if (!text) return '-';
        return text.replace('T', ' ').slice(0, 16);
    }

    public async save() {
        if (!this.canManage || this.saving || this.publishing || this.deleting) return;
        if (!String(this.form.name || '').trim() || !String(this.form.set_key || '').trim()) {
            await this.service.modal.error('세트 이름과 세트 키를 입력해주세요.');
            return;
        }
        if (!String(this.form.change_summary || '').trim()) {
            await this.service.modal.error('이번 버전의 변경 내용을 입력해주세요.');
            return;
        }
        const targetKey = String(this.form.set_key || '').trim().toLowerCase();
        const targetVersions = this.sets.filter((item: any) =>
            String(item?.scenario_type || '') === targetKey
        );
        const nextVersion = targetVersions.length === 0 ? 1 : Math.max(
            0,
            ...targetVersions.map((item: any) => Number(item.version || 0))
        ) + 1;
        const confirmed = await this.service.modal.show({
            title: this.form.publish_now ? '새 버전 저장 및 활성화' : '새 버전 초안 저장',
            message: `${this.form.name} v${nextVersion}을(를) 새 버전으로 저장합니다. 한국어 원문에서 생성 모델용 영어 파생본을 자동으로 준비하며, 기존 버전과 생성 결과는 유지됩니다.`,
            action: this.form.publish_now ? '저장·활성화' : '초안 저장',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;

        const savingPendingDraft = this.isNew;
        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                ...this.form,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 201) {
                await this.service.modal.error(data?.message || '프롬프트 세트를 저장하지 못했습니다.');
                return;
            }
            if (savingPendingDraft) {
                this.pendingDraft = null;
                this.isNew = false;
                this.cloneSource = null;
            }
            await this.load(data.scenario_type, Number(data.version || 0));
        } catch (_error) {
            await this.service.modal.error('프롬프트 세트를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async reuseVersion(item: any = this.currentSet()) {
        await this.publish(item, true);
    }

    public async deleteSet(item: any = this.currentSet()) {
        if (
            !this.canManage
            || this.isNew
            || this.saving
            || this.publishing
            || this.deleting
            || !item
        ) return;

        const setKey = String(item.scenario_type || '');
        const name = String(item.name || setKey);
        const versionCount = this.sets.filter((value: any) =>
            value.scenario_type === setKey
        ).length;
        const confirmed = await this.service.modal.show({
            title: '프롬프트 세트 전체 삭제',
            message: `${name} 세트의 모든 버전 ${versionCount}개를 삭제합니다. 삭제한 세트는 복구할 수 없습니다.`,
            action: '세트 삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        this.deleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_set', {
                set_key: setKey,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '프롬프트 세트를 삭제하지 못했습니다.');
                return;
            }
            this.selectedKey = '';
            this.selectedVersion = 0;
            this.isNew = false;
            await this.load();
            await this.service.modal.success(`${name} 프롬프트 세트를 삭제했습니다.`);
        } catch (_error) {
            await this.service.modal.error('프롬프트 세트를 삭제하지 못했습니다.');
        } finally {
            this.deleting = false;
            await this.service.render();
        }
    }

    public async publish(item: any = this.currentSet(), reuse: boolean = false) {
        if (
            !this.canManage
            || this.saving
            || this.publishing
            || this.deleting
            || !item
            || item.is_active
        ) return;
        const confirmed = await this.service.modal.show({
            title: reuse ? '프롬프트 버전 재사용' : '프롬프트 버전 활성화',
            message: `${item.name} v${item.version}을(를) 콘텐츠 생성에 사용합니다. 현재 활성 버전은 보관됩니다.`,
            action: reuse ? '재사용' : '활성화',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;
        this.publishing = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('publish', {
                set_key: item.scenario_type,
                version: item.version,
                reuse,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '프롬프트 버전을 활성화하지 못했습니다.');
                return;
            }
            await this.load(item.scenario_type, Number(item.version || 0));
        } catch (_error) {
            await this.service.modal.error('프롬프트 버전을 활성화하지 못했습니다.');
        } finally {
            this.publishing = false;
            await this.service.render();
        }
    }
}

export default PagePromptsComponent;